const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

window.dispatchCartUpdate = function (cartData, source = 'theme', details = {}) {
  publish(PUB_SUB_EVENTS.cartUpdate, {
    source: source,
    cartData: cartData,
    ...details
  });
  console.log('[cart-update] Event dispatched', { source, cart: cartData });
};


(function polyfill() {
  const relList = document.createElement("link").relList;
  if (relList && relList.supports && relList.supports("modulepreload")) {
    return;
  }
  for (const link of document.querySelectorAll('link[rel="modulepreload"]')) {
    processPreload(link);
  }
  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type !== "childList") {
        continue;
      }
      for (const node of mutation.addedNodes) {
        if (node.tagName === "LINK" && node.rel === "modulepreload")
          processPreload(node);
      }
    }
  }).observe(document, { childList: true, subtree: true });
  function getFetchOpts(link) {
    const fetchOpts = {};
    if (link.integrity)
      fetchOpts.integrity = link.integrity;
    if (link.referrerPolicy)
      fetchOpts.referrerPolicy = link.referrerPolicy;
    if (link.crossOrigin === "use-credentials")
      fetchOpts.credentials = "include";
    else if (link.crossOrigin === "anonymous")
      fetchOpts.credentials = "omit";
    else
      fetchOpts.credentials = "same-origin";
    return fetchOpts;
  }
  function processPreload(link) {
    if (link.ep)
      return;
    link.ep = true;
    const fetchOpts = getFetchOpts(link);
    fetch(link.href, fetchOpts);
  }
})();
const style$1 = "";
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
/*!
 * Splide.js
 * Version  : 4.1.4
 * License  : MIT
 * Copyright: 2022 Naotoshi Fujita
 */
var MEDIA_PREFERS_REDUCED_MOTION = "(prefers-reduced-motion: reduce)";
var CREATED = 1;
var MOUNTED = 2;
var IDLE = 3;
var MOVING = 4;
var SCROLLING = 5;
var DRAGGING = 6;
var DESTROYED = 7;
var STATES = {
  CREATED,
  MOUNTED,
  IDLE,
  MOVING,
  SCROLLING,
  DRAGGING,
  DESTROYED
};
function empty(array) {
  array.length = 0;
}
function slice(arrayLike, start, end) {
  return Array.prototype.slice.call(arrayLike, start, end);
}
function apply(func) {
  return func.bind.apply(func, [null].concat(slice(arguments, 1)));
}
var nextTick = setTimeout;
var noop = function noop2() {
};
function raf(func) {
  return requestAnimationFrame(func);
}
function typeOf(type, subject) {
  return typeof subject === type;
}
function isObject(subject) {
  return !isNull(subject) && typeOf("object", subject);
}
var isArray = Array.isArray;
var isFunction = apply(typeOf, "function");
var isString = apply(typeOf, "string");
var isUndefined = apply(typeOf, "undefined");
function isNull(subject) {
  return subject === null;
}
function isHTMLElement(subject) {
  try {
    return subject instanceof (subject.ownerDocument.defaultView || window).HTMLElement;
  } catch (e) {
    return false;
  }
}
function toArray(value) {
  return isArray(value) ? value : [value];
}
function forEach(values, iteratee) {
  toArray(values).forEach(iteratee);
}
function includes(array, value) {
  return array.indexOf(value) > -1;
}
function push(array, items) {
  array.push.apply(array, toArray(items));
  return array;
}
function toggleClass(elm, classes, add) {
  if (elm) {
    forEach(classes, function(name) {
      if (name) {
        elm.classList[add ? "add" : "remove"](name);
      }
    });
  }
}
function addClass(elm, classes) {
  toggleClass(elm, isString(classes) ? classes.split(" ") : classes, true);
}
function append(parent, children2) {
  forEach(children2, parent.appendChild.bind(parent));
}
function before(nodes, ref) {
  forEach(nodes, function(node) {
    var parent = (ref || node).parentNode;
    if (parent) {
      parent.insertBefore(node, ref);
    }
  });
}
function matches(elm, selector) {
  return isHTMLElement(elm) && (elm["msMatchesSelector"] || elm.matches).call(elm, selector);
}
function children(parent, selector) {
  var children2 = parent ? slice(parent.children) : [];
  return selector ? children2.filter(function(child2) {
    return matches(child2, selector);
  }) : children2;
}
function child(parent, selector) {
  return selector ? children(parent, selector)[0] : parent.firstElementChild;
}
var ownKeys = Object.keys;
function forOwn(object, iteratee, right) {
  if (object) {
    (right ? ownKeys(object).reverse() : ownKeys(object)).forEach(function(key) {
      key !== "__proto__" && iteratee(object[key], key);
    });
  }
  return object;
}
function assign(object) {
  slice(arguments, 1).forEach(function(source) {
    forOwn(source, function(value, key) {
      object[key] = source[key];
    });
  });
  return object;
}
function merge(object) {
  slice(arguments, 1).forEach(function(source) {
    forOwn(source, function(value, key) {
      if (isArray(value)) {
        object[key] = value.slice();
      } else if (isObject(value)) {
        object[key] = merge({}, isObject(object[key]) ? object[key] : {}, value);
      } else {
        object[key] = value;
      }
    });
  });
  return object;
}
function omit(object, keys) {
  forEach(keys || ownKeys(object), function(key) {
    delete object[key];
  });
}
function removeAttribute(elms, attrs) {
  forEach(elms, function(elm) {
    forEach(attrs, function(attr) {
      elm && elm.removeAttribute(attr);
    });
  });
}
function setAttribute(elms, attrs, value) {
  if (isObject(attrs)) {
    forOwn(attrs, function(value2, name) {
      setAttribute(elms, name, value2);
    });
  } else {
    forEach(elms, function(elm) {
      isNull(value) || value === "" ? removeAttribute(elm, attrs) : elm.setAttribute(attrs, String(value));
    });
  }
}
function create(tag, attrs, parent) {
  var elm = document.createElement(tag);
  if (attrs) {
    isString(attrs) ? addClass(elm, attrs) : setAttribute(elm, attrs);
  }
  parent && append(parent, elm);
  return elm;
}
function style(elm, prop, value) {
  if (isUndefined(value)) {
    return getComputedStyle(elm)[prop];
  }
  if (!isNull(value)) {
    elm.style[prop] = "" + value;
  }
}
function display(elm, display2) {
  style(elm, "display", display2);
}
function focus(elm) {
  elm["setActive"] && elm["setActive"]() || elm.focus({
    preventScroll: true
  });
}
function getAttribute(elm, attr) {
  return elm.getAttribute(attr);
}
function hasClass(elm, className) {
  return elm && elm.classList.contains(className);
}
function rect(target) {
  return target.getBoundingClientRect();
}
function remove(nodes) {
  forEach(nodes, function(node) {
    if (node && node.parentNode) {
      node.parentNode.removeChild(node);
    }
  });
}
function parseHtml(html) {
  return child(new DOMParser().parseFromString(html, "text/html").body);
}
function prevent(e, stopPropagation) {
  e.preventDefault();
  if (stopPropagation) {
    e.stopPropagation();
    e.stopImmediatePropagation();
  }
}
function query(parent, selector) {
  return parent && parent.querySelector(selector);
}
function queryAll(parent, selector) {
  return selector ? slice(parent.querySelectorAll(selector)) : [];
}
function removeClass(elm, classes) {
  toggleClass(elm, classes, false);
}
function timeOf(e) {
  return e.timeStamp;
}
function unit(value) {
  return isString(value) ? value : value ? value + "px" : "";
}
var PROJECT_CODE = "splide";
var DATA_ATTRIBUTE = "data-" + PROJECT_CODE;
function assert(condition, message) {
  if (!condition) {
    throw new Error("[" + PROJECT_CODE + "] " + (message || ""));
  }
}
var min = Math.min, max = Math.max, floor = Math.floor, ceil = Math.ceil, abs = Math.abs;
function approximatelyEqual(x, y, epsilon) {
  return abs(x - y) < epsilon;
}
function between(number, x, y, exclusive) {
  var minimum = min(x, y);
  var maximum = max(x, y);
  return exclusive ? minimum < number && number < maximum : minimum <= number && number <= maximum;
}
function clamp(number, x, y) {
  var minimum = min(x, y);
  var maximum = max(x, y);
  return min(max(minimum, number), maximum);
}
function sign(x) {
  return +(x > 0) - +(x < 0);
}
function format(string, replacements) {
  forEach(replacements, function(replacement) {
    string = string.replace("%s", "" + replacement);
  });
  return string;
}
function pad(number) {
  return number < 10 ? "0" + number : "" + number;
}
var ids = {};
function uniqueId(prefix) {
  return "" + prefix + pad(ids[prefix] = (ids[prefix] || 0) + 1);
}
function EventBinder() {
  var listeners = [];
  function bind(targets, events, callback, options) {
    forEachEvent(targets, events, function(target, event, namespace) {
      var isEventTarget = "addEventListener" in target;
      var remover = isEventTarget ? target.removeEventListener.bind(target, event, callback, options) : target["removeListener"].bind(target, callback);
      isEventTarget ? target.addEventListener(event, callback, options) : target["addListener"](callback);
      listeners.push([target, event, namespace, callback, remover]);
    });
  }
  function unbind(targets, events, callback) {
    forEachEvent(targets, events, function(target, event, namespace) {
      listeners = listeners.filter(function(listener) {
        if (listener[0] === target && listener[1] === event && listener[2] === namespace && (!callback || listener[3] === callback)) {
          listener[4]();
          return false;
        }
        return true;
      });
    });
  }
  function dispatch(target, type, detail) {
    var e;
    var bubbles = true;
    if (typeof CustomEvent === "function") {
      e = new CustomEvent(type, {
        bubbles,
        detail
      });
    } else {
      e = document.createEvent("CustomEvent");
      e.initCustomEvent(type, bubbles, false, detail);
    }
    target.dispatchEvent(e);
    return e;
  }
  function forEachEvent(targets, events, iteratee) {
    forEach(targets, function(target) {
      target && forEach(events, function(events2) {
        events2.split(" ").forEach(function(eventNS) {
          var fragment = eventNS.split(".");
          iteratee(target, fragment[0], fragment[1]);
        });
      });
    });
  }
  function destroy() {
    listeners.forEach(function(data) {
      data[4]();
    });
    empty(listeners);
  }
  return {
    bind,
    unbind,
    dispatch,
    destroy
  };
}
var EVENT_MOUNTED = "mounted";
var EVENT_READY = "ready";
var EVENT_MOVE = "move";
var EVENT_MOVED = "moved";
var EVENT_CLICK = "click";
var EVENT_ACTIVE = "active";
var EVENT_INACTIVE = "inactive";
var EVENT_VISIBLE = "visible";
var EVENT_HIDDEN = "hidden";
var EVENT_REFRESH = "refresh";
var EVENT_UPDATED = "updated";
var EVENT_RESIZE = "resize";
var EVENT_RESIZED = "resized";
var EVENT_DRAG = "drag";
var EVENT_DRAGGING = "dragging";
var EVENT_DRAGGED = "dragged";
var EVENT_SCROLL = "scroll";
var EVENT_SCROLLED = "scrolled";
var EVENT_OVERFLOW = "overflow";
var EVENT_DESTROY = "destroy";
var EVENT_ARROWS_MOUNTED = "arrows:mounted";
var EVENT_ARROWS_UPDATED = "arrows:updated";
var EVENT_PAGINATION_MOUNTED = "pagination:mounted";
var EVENT_PAGINATION_UPDATED = "pagination:updated";
var EVENT_NAVIGATION_MOUNTED = "navigation:mounted";
var EVENT_AUTOPLAY_PLAY = "autoplay:play";
var EVENT_AUTOPLAY_PLAYING = "autoplay:playing";
var EVENT_AUTOPLAY_PAUSE = "autoplay:pause";
var EVENT_LAZYLOAD_LOADED = "lazyload:loaded";
var EVENT_SLIDE_KEYDOWN = "sk";
var EVENT_SHIFTED = "sh";
var EVENT_END_INDEX_CHANGED = "ei";
function EventInterface(Splide2) {
  var bus = Splide2 ? Splide2.event.bus : document.createDocumentFragment();
  var binder = EventBinder();
  function on(events, callback) {
    binder.bind(bus, toArray(events).join(" "), function(e) {
      callback.apply(callback, isArray(e.detail) ? e.detail : []);
    });
  }
  function emit(event) {
    binder.dispatch(bus, event, slice(arguments, 1));
  }
  if (Splide2) {
    Splide2.event.on(EVENT_DESTROY, binder.destroy);
  }
  return assign(binder, {
    bus,
    on,
    off: apply(binder.unbind, bus),
    emit
  });
}
function RequestInterval(interval, onInterval, onUpdate, limit) {
  var now = Date.now;
  var startTime;
  var rate = 0;
  var id;
  var paused = true;
  var count = 0;
  function update() {
    if (!paused) {
      rate = interval ? min((now() - startTime) / interval, 1) : 1;
      onUpdate && onUpdate(rate);
      if (rate >= 1) {
        onInterval();
        startTime = now();
        if (limit && ++count >= limit) {
          return pause();
        }
      }
      id = raf(update);
    }
  }
  function start(resume) {
    resume || cancel();
    startTime = now() - (resume ? rate * interval : 0);
    paused = false;
    id = raf(update);
  }
  function pause() {
    paused = true;
  }
  function rewind() {
    startTime = now();
    rate = 0;
    if (onUpdate) {
      onUpdate(rate);
    }
  }
  function cancel() {
    id && cancelAnimationFrame(id);
    rate = 0;
    id = 0;
    paused = true;
  }
  function set(time) {
    interval = time;
  }
  function isPaused() {
    return paused;
  }
  return {
    start,
    rewind,
    pause,
    cancel,
    set,
    isPaused
  };
}
function State(initialState) {
  var state = initialState;
  function set(value) {
    state = value;
  }
  function is(states) {
    return includes(toArray(states), state);
  }
  return {
    set,
    is
  };
}
function Throttle(func, duration) {
  var interval = RequestInterval(duration || 0, func, null, 1);
  return function() {
    interval.isPaused() && interval.start();
  };
}
function Media(Splide2, Components2, options) {
  var state = Splide2.state;
  var breakpoints = options.breakpoints || {};
  var reducedMotion = options.reducedMotion || {};
  var binder = EventBinder();
  var queries = [];
  function setup() {
    var isMin = options.mediaQuery === "min";
    ownKeys(breakpoints).sort(function(n, m) {
      return isMin ? +n - +m : +m - +n;
    }).forEach(function(key) {
      register(breakpoints[key], "(" + (isMin ? "min" : "max") + "-width:" + key + "px)");
    });
    register(reducedMotion, MEDIA_PREFERS_REDUCED_MOTION);
    update();
  }
  function destroy(completely) {
    if (completely) {
      binder.destroy();
    }
  }
  function register(options2, query2) {
    var queryList = matchMedia(query2);
    binder.bind(queryList, "change", update);
    queries.push([options2, queryList]);
  }
  function update() {
    var destroyed = state.is(DESTROYED);
    var direction = options.direction;
    var merged = queries.reduce(function(merged2, entry) {
      return merge(merged2, entry[1].matches ? entry[0] : {});
    }, {});
    omit(options);
    set(merged);
    if (options.destroy) {
      Splide2.destroy(options.destroy === "completely");
    } else if (destroyed) {
      destroy(true);
      Splide2.mount();
    } else {
      direction !== options.direction && Splide2.refresh();
    }
  }
  function reduce(enable) {
    if (matchMedia(MEDIA_PREFERS_REDUCED_MOTION).matches) {
      enable ? merge(options, reducedMotion) : omit(options, ownKeys(reducedMotion));
    }
  }
  function set(opts, base, notify) {
    merge(options, opts);
    base && merge(Object.getPrototypeOf(options), opts);
    if (notify || !state.is(CREATED)) {
      Splide2.emit(EVENT_UPDATED, options);
    }
  }
  return {
    setup,
    destroy,
    reduce,
    set
  };
}
var ARROW = "Arrow";
var ARROW_LEFT = ARROW + "Left";
var ARROW_RIGHT = ARROW + "Right";
var ARROW_UP = ARROW + "Up";
var ARROW_DOWN = ARROW + "Down";
var RTL = "rtl";
var TTB = "ttb";
var ORIENTATION_MAP = {
  width: ["height"],
  left: ["top", "right"],
  right: ["bottom", "left"],
  x: ["y"],
  X: ["Y"],
  Y: ["X"],
  ArrowLeft: [ARROW_UP, ARROW_RIGHT],
  ArrowRight: [ARROW_DOWN, ARROW_LEFT]
};
function Direction(Splide2, Components2, options) {
  function resolve(prop, axisOnly, direction) {
    direction = direction || options.direction;
    var index = direction === RTL && !axisOnly ? 1 : direction === TTB ? 0 : -1;
    return ORIENTATION_MAP[prop] && ORIENTATION_MAP[prop][index] || prop.replace(/width|left|right/i, function(match, offset) {
      var replacement = ORIENTATION_MAP[match.toLowerCase()][index] || match;
      return offset > 0 ? replacement.charAt(0).toUpperCase() + replacement.slice(1) : replacement;
    });
  }
  function orient(value) {
    return value * (options.direction === RTL ? 1 : -1);
  }
  return {
    resolve,
    orient
  };
}
var ROLE = "role";
var TAB_INDEX = "tabindex";
var DISABLED = "disabled";
var ARIA_PREFIX = "aria-";
var ARIA_CONTROLS = ARIA_PREFIX + "controls";
var ARIA_CURRENT = ARIA_PREFIX + "current";
var ARIA_SELECTED = ARIA_PREFIX + "selected";
var ARIA_LABEL = ARIA_PREFIX + "label";
var ARIA_LABELLEDBY = ARIA_PREFIX + "labelledby";
var ARIA_HIDDEN = ARIA_PREFIX + "hidden";
var ARIA_ORIENTATION = ARIA_PREFIX + "orientation";
var ARIA_ROLEDESCRIPTION = ARIA_PREFIX + "roledescription";
var ARIA_LIVE = ARIA_PREFIX + "live";
var ARIA_BUSY = ARIA_PREFIX + "busy";
var ARIA_ATOMIC = ARIA_PREFIX + "atomic";
var ALL_ATTRIBUTES = [ROLE, TAB_INDEX, DISABLED, ARIA_CONTROLS, ARIA_CURRENT, ARIA_LABEL, ARIA_LABELLEDBY, ARIA_HIDDEN, ARIA_ORIENTATION, ARIA_ROLEDESCRIPTION];
var CLASS_PREFIX = PROJECT_CODE + "__";
var STATUS_CLASS_PREFIX = "is-";
var CLASS_ROOT = PROJECT_CODE;
var CLASS_TRACK = CLASS_PREFIX + "track";
var CLASS_LIST = CLASS_PREFIX + "list";
var CLASS_SLIDE = CLASS_PREFIX + "slide";
var CLASS_CLONE = CLASS_SLIDE + "--clone";
var CLASS_CONTAINER = CLASS_SLIDE + "__container";
var CLASS_ARROWS = CLASS_PREFIX + "arrows";
var CLASS_ARROW = CLASS_PREFIX + "arrow";
var CLASS_ARROW_PREV = CLASS_ARROW + "--prev";
var CLASS_ARROW_NEXT = CLASS_ARROW + "--next";
var CLASS_PAGINATION = CLASS_PREFIX + "pagination";
var CLASS_PAGINATION_PAGE = CLASS_PAGINATION + "__page";
var CLASS_PROGRESS = CLASS_PREFIX + "progress";
var CLASS_PROGRESS_BAR = CLASS_PROGRESS + "__bar";
var CLASS_TOGGLE = CLASS_PREFIX + "toggle";
var CLASS_SPINNER = CLASS_PREFIX + "spinner";
var CLASS_SR = CLASS_PREFIX + "sr";
var CLASS_INITIALIZED = STATUS_CLASS_PREFIX + "initialized";
var CLASS_ACTIVE = STATUS_CLASS_PREFIX + "active";
var CLASS_PREV = STATUS_CLASS_PREFIX + "prev";
var CLASS_NEXT = STATUS_CLASS_PREFIX + "next";
var CLASS_VISIBLE = STATUS_CLASS_PREFIX + "visible";
var CLASS_LOADING = STATUS_CLASS_PREFIX + "loading";
var CLASS_FOCUS_IN = STATUS_CLASS_PREFIX + "focus-in";
var CLASS_OVERFLOW = STATUS_CLASS_PREFIX + "overflow";
var STATUS_CLASSES = [CLASS_ACTIVE, CLASS_VISIBLE, CLASS_PREV, CLASS_NEXT, CLASS_LOADING, CLASS_FOCUS_IN, CLASS_OVERFLOW];
var CLASSES = {
  slide: CLASS_SLIDE,
  clone: CLASS_CLONE,
  arrows: CLASS_ARROWS,
  arrow: CLASS_ARROW,
  prev: CLASS_ARROW_PREV,
  next: CLASS_ARROW_NEXT,
  pagination: CLASS_PAGINATION,
  page: CLASS_PAGINATION_PAGE,
  spinner: CLASS_SPINNER
};
function closest(from, selector) {
  if (isFunction(from.closest)) {
    return from.closest(selector);
  }
  var elm = from;
  while (elm && elm.nodeType === 1) {
    if (matches(elm, selector)) {
      break;
    }
    elm = elm.parentElement;
  }
  return elm;
}
var FRICTION = 5;
var LOG_INTERVAL = 200;
var POINTER_DOWN_EVENTS = "touchstart mousedown";
var POINTER_MOVE_EVENTS = "touchmove mousemove";
var POINTER_UP_EVENTS = "touchend touchcancel mouseup click";
function Elements(Splide2, Components2, options) {
  var _EventInterface = EventInterface(Splide2), on = _EventInterface.on, bind = _EventInterface.bind;
  var root = Splide2.root;
  var i18n = options.i18n;
  var elements = {};
  var slides = [];
  var rootClasses = [];
  var trackClasses = [];
  var track;
  var list;
  var isUsingKey;
  function setup() {
    collect();
    init();
    update();
  }
  function mount() {
    on(EVENT_REFRESH, destroy);
    on(EVENT_REFRESH, setup);
    on(EVENT_UPDATED, update);
    bind(document, POINTER_DOWN_EVENTS + " keydown", function(e) {
      isUsingKey = e.type === "keydown";
    }, {
      capture: true
    });
    bind(root, "focusin", function() {
      toggleClass(root, CLASS_FOCUS_IN, !!isUsingKey);
    });
  }
  function destroy(completely) {
    var attrs = ALL_ATTRIBUTES.concat("style");
    empty(slides);
    removeClass(root, rootClasses);
    removeClass(track, trackClasses);
    removeAttribute([track, list], attrs);
    removeAttribute(root, completely ? attrs : ["style", ARIA_ROLEDESCRIPTION]);
  }
  function update() {
    removeClass(root, rootClasses);
    removeClass(track, trackClasses);
    rootClasses = getClasses(CLASS_ROOT);
    trackClasses = getClasses(CLASS_TRACK);
    addClass(root, rootClasses);
    addClass(track, trackClasses);
    setAttribute(root, ARIA_LABEL, options.label);
    setAttribute(root, ARIA_LABELLEDBY, options.labelledby);
  }
  function collect() {
    track = find("." + CLASS_TRACK);
    list = child(track, "." + CLASS_LIST);
    assert(track && list, "A track/list element is missing.");
    push(slides, children(list, "." + CLASS_SLIDE + ":not(." + CLASS_CLONE + ")"));
    forOwn({
      arrows: CLASS_ARROWS,
      pagination: CLASS_PAGINATION,
      prev: CLASS_ARROW_PREV,
      next: CLASS_ARROW_NEXT,
      bar: CLASS_PROGRESS_BAR,
      toggle: CLASS_TOGGLE
    }, function(className, key) {
      elements[key] = find("." + className);
    });
    assign(elements, {
      root,
      track,
      list,
      slides
    });
  }
  function init() {
    var id = root.id || uniqueId(PROJECT_CODE);
    var role = options.role;
    root.id = id;
    track.id = track.id || id + "-track";
    list.id = list.id || id + "-list";
    if (!getAttribute(root, ROLE) && root.tagName !== "SECTION" && role) {
      setAttribute(root, ROLE, role);
    }
    setAttribute(root, ARIA_ROLEDESCRIPTION, i18n.carousel);
    setAttribute(list, ROLE, "presentation");
  }
  function find(selector) {
    var elm = query(root, selector);
    return elm && closest(elm, "." + CLASS_ROOT) === root ? elm : void 0;
  }
  function getClasses(base) {
    return [base + "--" + options.type, base + "--" + options.direction, options.drag && base + "--draggable", options.isNavigation && base + "--nav", base === CLASS_ROOT && CLASS_ACTIVE];
  }
  return assign(elements, {
    setup,
    mount,
    destroy
  });
}
var SLIDE = "slide";
var LOOP = "loop";
var FADE = "fade";
function Slide$1(Splide2, index, slideIndex, slide) {
  var event = EventInterface(Splide2);
  var on = event.on, emit = event.emit, bind = event.bind;
  var Components = Splide2.Components, root = Splide2.root, options = Splide2.options;
  var isNavigation = options.isNavigation, updateOnMove = options.updateOnMove, i18n = options.i18n, pagination = options.pagination, slideFocus = options.slideFocus;
  var resolve = Components.Direction.resolve;
  var styles = getAttribute(slide, "style");
  var label = getAttribute(slide, ARIA_LABEL);
  var isClone = slideIndex > -1;
  var container = child(slide, "." + CLASS_CONTAINER);
  var destroyed;
  function mount() {
    if (!isClone) {
      slide.id = root.id + "-slide" + pad(index + 1);
      setAttribute(slide, ROLE, pagination ? "tabpanel" : "group");
      setAttribute(slide, ARIA_ROLEDESCRIPTION, i18n.slide);
      setAttribute(slide, ARIA_LABEL, label || format(i18n.slideLabel, [index + 1, Splide2.length]));
    }
    listen();
  }
  function listen() {
    bind(slide, "click", apply(emit, EVENT_CLICK, self));
    bind(slide, "keydown", apply(emit, EVENT_SLIDE_KEYDOWN, self));
    on([EVENT_MOVED, EVENT_SHIFTED, EVENT_SCROLLED], update);
    on(EVENT_NAVIGATION_MOUNTED, initNavigation);
    if (updateOnMove) {
      on(EVENT_MOVE, onMove);
    }
  }
  function destroy() {
    destroyed = true;
    event.destroy();
    removeClass(slide, STATUS_CLASSES);
    removeAttribute(slide, ALL_ATTRIBUTES);
    setAttribute(slide, "style", styles);
    setAttribute(slide, ARIA_LABEL, label || "");
  }
  function initNavigation() {
    var controls = Splide2.splides.map(function(target) {
      var Slide2 = target.splide.Components.Slides.getAt(index);
      return Slide2 ? Slide2.slide.id : "";
    }).join(" ");
    setAttribute(slide, ARIA_LABEL, format(i18n.slideX, (isClone ? slideIndex : index) + 1));
    setAttribute(slide, ARIA_CONTROLS, controls);
    setAttribute(slide, ROLE, slideFocus ? "button" : "");
    slideFocus && removeAttribute(slide, ARIA_ROLEDESCRIPTION);
  }
  function onMove() {
    if (!destroyed) {
      update();
    }
  }
  function update() {
    if (!destroyed) {
      var curr = Splide2.index;
      updateActivity();
      updateVisibility();
      toggleClass(slide, CLASS_PREV, index === curr - 1);
      toggleClass(slide, CLASS_NEXT, index === curr + 1);
    }
  }
  function updateActivity() {
    var active = isActive();
    if (active !== hasClass(slide, CLASS_ACTIVE)) {
      toggleClass(slide, CLASS_ACTIVE, active);
      setAttribute(slide, ARIA_CURRENT, isNavigation && active || "");
      emit(active ? EVENT_ACTIVE : EVENT_INACTIVE, self);
    }
  }
  function updateVisibility() {
    var visible = isVisible();
    var hidden = !visible && (!isActive() || isClone);
    if (!Splide2.state.is([MOVING, SCROLLING])) {
      setAttribute(slide, ARIA_HIDDEN, hidden || "");
    }
    setAttribute(queryAll(slide, options.focusableNodes || ""), TAB_INDEX, hidden ? -1 : "");
    if (slideFocus) {
      setAttribute(slide, TAB_INDEX, hidden ? -1 : 0);
    }
    if (visible !== hasClass(slide, CLASS_VISIBLE)) {
      toggleClass(slide, CLASS_VISIBLE, visible);
      emit(visible ? EVENT_VISIBLE : EVENT_HIDDEN, self);
    }
    if (!visible && document.activeElement === slide) {
      var Slide2 = Components.Slides.getAt(Splide2.index);
      Slide2 && focus(Slide2.slide);
    }
  }
  function style$12(prop, value, useContainer) {
    style(useContainer && container || slide, prop, value);
  }
  function isActive() {
    var curr = Splide2.index;
    return curr === index || options.cloneStatus && curr === slideIndex;
  }
  function isVisible() {
    if (Splide2.is(FADE)) {
      return isActive();
    }
    var trackRect = rect(Components.Elements.track);
    var slideRect = rect(slide);
    var left = resolve("left", true);
    var right = resolve("right", true);
    return floor(trackRect[left]) <= ceil(slideRect[left]) && floor(slideRect[right]) <= ceil(trackRect[right]);
  }
  function isWithin(from, distance) {
    var diff = abs(from - index);
    if (!isClone && (options.rewind || Splide2.is(LOOP))) {
      diff = min(diff, Splide2.length - diff);
    }
    return diff <= distance;
  }
  var self = {
    index,
    slideIndex,
    slide,
    container,
    isClone,
    mount,
    destroy,
    update,
    style: style$12,
    isWithin
  };
  return self;
}
function Slides(Splide2, Components2, options) {
  var _EventInterface2 = EventInterface(Splide2), on = _EventInterface2.on, emit = _EventInterface2.emit, bind = _EventInterface2.bind;
  var _Components2$Elements = Components2.Elements, slides = _Components2$Elements.slides, list = _Components2$Elements.list;
  var Slides2 = [];
  function mount() {
    init();
    on(EVENT_REFRESH, destroy);
    on(EVENT_REFRESH, init);
  }
  function init() {
    slides.forEach(function(slide, index) {
      register(slide, index, -1);
    });
  }
  function destroy() {
    forEach$1(function(Slide2) {
      Slide2.destroy();
    });
    empty(Slides2);
  }
  function update() {
    forEach$1(function(Slide2) {
      Slide2.update();
    });
  }
  function register(slide, index, slideIndex) {
    var object = Slide$1(Splide2, index, slideIndex, slide);
    object.mount();
    Slides2.push(object);
    Slides2.sort(function(Slide1, Slide2) {
      return Slide1.index - Slide2.index;
    });
  }
  function get(excludeClones) {
    return excludeClones ? filter(function(Slide2) {
      return !Slide2.isClone;
    }) : Slides2;
  }
  function getIn(page) {
    var Controller2 = Components2.Controller;
    var index = Controller2.toIndex(page);
    var max2 = Controller2.hasFocus() ? 1 : options.perPage;
    return filter(function(Slide2) {
      return between(Slide2.index, index, index + max2 - 1);
    });
  }
  function getAt(index) {
    return filter(index)[0];
  }
  function add(items, index) {
    forEach(items, function(slide) {
      if (isString(slide)) {
        slide = parseHtml(slide);
      }
      if (isHTMLElement(slide)) {
        var ref = slides[index];
        ref ? before(slide, ref) : append(list, slide);
        addClass(slide, options.classes.slide);
        observeImages(slide, apply(emit, EVENT_RESIZE));
      }
    });
    emit(EVENT_REFRESH);
  }
  function remove$1(matcher) {
    remove(filter(matcher).map(function(Slide2) {
      return Slide2.slide;
    }));
    emit(EVENT_REFRESH);
  }
  function forEach$1(iteratee, excludeClones) {
    get(excludeClones).forEach(iteratee);
  }
  function filter(matcher) {
    return Slides2.filter(isFunction(matcher) ? matcher : function(Slide2) {
      return isString(matcher) ? matches(Slide2.slide, matcher) : includes(toArray(matcher), Slide2.index);
    });
  }
  function style2(prop, value, useContainer) {
    forEach$1(function(Slide2) {
      Slide2.style(prop, value, useContainer);
    });
  }
  function observeImages(elm, callback) {
    var images = queryAll(elm, "img");
    var length = images.length;
    if (length) {
      images.forEach(function(img) {
        bind(img, "load error", function() {
          if (!--length) {
            callback();
          }
        });
      });
    } else {
      callback();
    }
  }
  function getLength(excludeClones) {
    return excludeClones ? slides.length : Slides2.length;
  }
  function isEnough() {
    return Slides2.length > options.perPage;
  }
  return {
    mount,
    destroy,
    update,
    register,
    get,
    getIn,
    getAt,
    add,
    remove: remove$1,
    forEach: forEach$1,
    filter,
    style: style2,
    getLength,
    isEnough
  };
}
function Layout(Splide2, Components2, options) {
  var _EventInterface3 = EventInterface(Splide2), on = _EventInterface3.on, bind = _EventInterface3.bind, emit = _EventInterface3.emit;
  var Slides2 = Components2.Slides;
  var resolve = Components2.Direction.resolve;
  var _Components2$Elements2 = Components2.Elements, root = _Components2$Elements2.root, track = _Components2$Elements2.track, list = _Components2$Elements2.list;
  var getAt = Slides2.getAt, styleSlides = Slides2.style;
  var vertical;
  var rootRect;
  var overflow;
  function mount() {
    init();
    bind(window, "resize load", Throttle(apply(emit, EVENT_RESIZE)));
    on([EVENT_UPDATED, EVENT_REFRESH], init);
    on(EVENT_RESIZE, resize);
  }
  function init() {
    vertical = options.direction === TTB;
    style(root, "maxWidth", unit(options.width));
    style(track, resolve("paddingLeft"), cssPadding(false));
    style(track, resolve("paddingRight"), cssPadding(true));
    resize(true);
  }
  function resize(force) {
    var newRect = rect(root);
    if (force || rootRect.width !== newRect.width || rootRect.height !== newRect.height) {
      style(track, "height", cssTrackHeight());
      styleSlides(resolve("marginRight"), unit(options.gap));
      styleSlides("width", cssSlideWidth());
      styleSlides("height", cssSlideHeight(), true);
      rootRect = newRect;
      emit(EVENT_RESIZED);
      if (overflow !== (overflow = isOverflow())) {
        toggleClass(root, CLASS_OVERFLOW, overflow);
        emit(EVENT_OVERFLOW, overflow);
      }
    }
  }
  function cssPadding(right) {
    var padding = options.padding;
    var prop = resolve(right ? "right" : "left");
    return padding && unit(padding[prop] || (isObject(padding) ? 0 : padding)) || "0px";
  }
  function cssTrackHeight() {
    var height = "";
    if (vertical) {
      height = cssHeight();
      assert(height, "height or heightRatio is missing.");
      height = "calc(" + height + " - " + cssPadding(false) + " - " + cssPadding(true) + ")";
    }
    return height;
  }
  function cssHeight() {
    return unit(options.height || rect(list).width * options.heightRatio);
  }
  function cssSlideWidth() {
    return options.autoWidth ? null : unit(options.fixedWidth) || (vertical ? "" : cssSlideSize());
  }
  function cssSlideHeight() {
    return unit(options.fixedHeight) || (vertical ? options.autoHeight ? null : cssSlideSize() : cssHeight());
  }
  function cssSlideSize() {
    var gap = unit(options.gap);
    return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
  }
  function listSize() {
    return rect(list)[resolve("width")];
  }
  function slideSize(index, withoutGap) {
    var Slide2 = getAt(index || 0);
    return Slide2 ? rect(Slide2.slide)[resolve("width")] + (withoutGap ? 0 : getGap()) : 0;
  }
  function totalSize(index, withoutGap) {
    var Slide2 = getAt(index);
    if (Slide2) {
      var right = rect(Slide2.slide)[resolve("right")];
      var left = rect(list)[resolve("left")];
      return abs(right - left) + (withoutGap ? 0 : getGap());
    }
    return 0;
  }
  function sliderSize(withoutGap) {
    return totalSize(Splide2.length - 1) - totalSize(0) + slideSize(0, withoutGap);
  }
  function getGap() {
    var Slide2 = getAt(0);
    return Slide2 && parseFloat(style(Slide2.slide, resolve("marginRight"))) || 0;
  }
  function getPadding(right) {
    return parseFloat(style(track, resolve("padding" + (right ? "Right" : "Left")))) || 0;
  }
  function isOverflow() {
    return Splide2.is(FADE) || sliderSize(true) > listSize();
  }
  return {
    mount,
    resize,
    listSize,
    slideSize,
    sliderSize,
    totalSize,
    getPadding,
    isOverflow
  };
}
var MULTIPLIER = 2;
function Clones(Splide2, Components2, options) {
  var event = EventInterface(Splide2);
  var on = event.on;
  var Elements2 = Components2.Elements, Slides2 = Components2.Slides;
  var resolve = Components2.Direction.resolve;
  var clones = [];
  var cloneCount;
  function mount() {
    on(EVENT_REFRESH, remount);
    on([EVENT_UPDATED, EVENT_RESIZE], observe);
    if (cloneCount = computeCloneCount()) {
      generate(cloneCount);
      Components2.Layout.resize(true);
    }
  }
  function remount() {
    destroy();
    mount();
  }
  function destroy() {
    remove(clones);
    empty(clones);
    event.destroy();
  }
  function observe() {
    var count = computeCloneCount();
    if (cloneCount !== count) {
      if (cloneCount < count || !count) {
        event.emit(EVENT_REFRESH);
      }
    }
  }
  function generate(count) {
    var slides = Slides2.get().slice();
    var length = slides.length;
    if (length) {
      while (slides.length < count) {
        push(slides, slides);
      }
      push(slides.slice(-count), slides.slice(0, count)).forEach(function(Slide2, index) {
        var isHead = index < count;
        var clone = cloneDeep(Slide2.slide, index);
        isHead ? before(clone, slides[0].slide) : append(Elements2.list, clone);
        push(clones, clone);
        Slides2.register(clone, index - count + (isHead ? 0 : length), Slide2.index);
      });
    }
  }
  function cloneDeep(elm, index) {
    var clone = elm.cloneNode(true);
    addClass(clone, options.classes.clone);
    clone.id = Splide2.root.id + "-clone" + pad(index + 1);
    return clone;
  }
  function computeCloneCount() {
    var clones2 = options.clones;
    if (!Splide2.is(LOOP)) {
      clones2 = 0;
    } else if (isUndefined(clones2)) {
      var fixedSize = options[resolve("fixedWidth")] && Components2.Layout.slideSize(0);
      var fixedCount = fixedSize && ceil(rect(Elements2.track)[resolve("width")] / fixedSize);
      clones2 = fixedCount || options[resolve("autoWidth")] && Splide2.length || options.perPage * MULTIPLIER;
    }
    return clones2;
  }
  return {
    mount,
    destroy
  };
}
function Move(Splide2, Components2, options) {
  var _EventInterface4 = EventInterface(Splide2), on = _EventInterface4.on, emit = _EventInterface4.emit;
  var set = Splide2.state.set;
  var _Components2$Layout = Components2.Layout, slideSize = _Components2$Layout.slideSize, getPadding = _Components2$Layout.getPadding, totalSize = _Components2$Layout.totalSize, listSize = _Components2$Layout.listSize, sliderSize = _Components2$Layout.sliderSize;
  var _Components2$Directio = Components2.Direction, resolve = _Components2$Directio.resolve, orient = _Components2$Directio.orient;
  var _Components2$Elements3 = Components2.Elements, list = _Components2$Elements3.list, track = _Components2$Elements3.track;
  var Transition;
  function mount() {
    Transition = Components2.Transition;
    on([EVENT_MOUNTED, EVENT_RESIZED, EVENT_UPDATED, EVENT_REFRESH], reposition);
  }
  function reposition() {
    if (!Components2.Controller.isBusy()) {
      Components2.Scroll.cancel();
      jump(Splide2.index);
      Components2.Slides.update();
    }
  }
  function move(dest, index, prev, callback) {
    if (dest !== index && canShift(dest > prev)) {
      cancel();
      translate(shift(getPosition(), dest > prev), true);
    }
    set(MOVING);
    emit(EVENT_MOVE, index, prev, dest);
    Transition.start(index, function() {
      set(IDLE);
      emit(EVENT_MOVED, index, prev, dest);
      callback && callback();
    });
  }
  function jump(index) {
    translate(toPosition(index, true));
  }
  function translate(position, preventLoop) {
    if (!Splide2.is(FADE)) {
      var destination = preventLoop ? position : loop(position);
      style(list, "transform", "translate" + resolve("X") + "(" + destination + "px)");
      position !== destination && emit(EVENT_SHIFTED);
    }
  }
  function loop(position) {
    if (Splide2.is(LOOP)) {
      var index = toIndex(position);
      var exceededMax = index > Components2.Controller.getEnd();
      var exceededMin = index < 0;
      if (exceededMin || exceededMax) {
        position = shift(position, exceededMax);
      }
    }
    return position;
  }
  function shift(position, backwards) {
    var excess = position - getLimit(backwards);
    var size = sliderSize();
    position -= orient(size * (ceil(abs(excess) / size) || 1)) * (backwards ? 1 : -1);
    return position;
  }
  function cancel() {
    translate(getPosition(), true);
    Transition.cancel();
  }
  function toIndex(position) {
    var Slides2 = Components2.Slides.get();
    var index = 0;
    var minDistance = Infinity;
    for (var i = 0; i < Slides2.length; i++) {
      var slideIndex = Slides2[i].index;
      var distance = abs(toPosition(slideIndex, true) - position);
      if (distance <= minDistance) {
        minDistance = distance;
        index = slideIndex;
      } else {
        break;
      }
    }
    return index;
  }
  function toPosition(index, trimming) {
    var position = orient(totalSize(index - 1) - offset(index));
    return trimming ? trim(position) : position;
  }
  function getPosition() {
    var left = resolve("left");
    return rect(list)[left] - rect(track)[left] + orient(getPadding(false));
  }
  function trim(position) {
    if (options.trimSpace && Splide2.is(SLIDE)) {
      position = clamp(position, 0, orient(sliderSize(true) - listSize()));
    }
    return position;
  }
  function offset(index) {
    var focus2 = options.focus;
    return focus2 === "center" ? (listSize() - slideSize(index, true)) / 2 : +focus2 * slideSize(index) || 0;
  }
  function getLimit(max2) {
    return toPosition(max2 ? Components2.Controller.getEnd() : 0, !!options.trimSpace);
  }
  function canShift(backwards) {
    var shifted = orient(shift(getPosition(), backwards));
    return backwards ? shifted >= 0 : shifted <= list[resolve("scrollWidth")] - rect(track)[resolve("width")];
  }
  function exceededLimit(max2, position) {
    position = isUndefined(position) ? getPosition() : position;
    var exceededMin = max2 !== true && orient(position) < orient(getLimit(false));
    var exceededMax = max2 !== false && orient(position) > orient(getLimit(true));
    return exceededMin || exceededMax;
  }
  return {
    mount,
    move,
    jump,
    translate,
    shift,
    cancel,
    toIndex,
    toPosition,
    getPosition,
    getLimit,
    exceededLimit,
    reposition
  };
}
function Controller(Splide2, Components2, options) {
  var _EventInterface5 = EventInterface(Splide2), on = _EventInterface5.on, emit = _EventInterface5.emit;
  var Move2 = Components2.Move;
  var getPosition = Move2.getPosition, getLimit = Move2.getLimit, toPosition = Move2.toPosition;
  var _Components2$Slides = Components2.Slides, isEnough = _Components2$Slides.isEnough, getLength = _Components2$Slides.getLength;
  var omitEnd = options.omitEnd;
  var isLoop = Splide2.is(LOOP);
  var isSlide = Splide2.is(SLIDE);
  var getNext = apply(getAdjacent, false);
  var getPrev = apply(getAdjacent, true);
  var currIndex = options.start || 0;
  var endIndex;
  var prevIndex = currIndex;
  var slideCount;
  var perMove;
  var perPage;
  function mount() {
    init();
    on([EVENT_UPDATED, EVENT_REFRESH, EVENT_END_INDEX_CHANGED], init);
    on(EVENT_RESIZED, onResized);
  }
  function init() {
    slideCount = getLength(true);
    perMove = options.perMove;
    perPage = options.perPage;
    endIndex = getEnd();
    var index = clamp(currIndex, 0, omitEnd ? endIndex : slideCount - 1);
    if (index !== currIndex) {
      currIndex = index;
      Move2.reposition();
    }
  }
  function onResized() {
    if (endIndex !== getEnd()) {
      emit(EVENT_END_INDEX_CHANGED);
    }
  }
  function go(control, allowSameIndex, callback) {
    if (!isBusy()) {
      var dest = parse(control);
      var index = loop(dest);
      if (index > -1 && (allowSameIndex || index !== currIndex)) {
        setIndex(index);
        Move2.move(dest, index, prevIndex, callback);
      }
    }
  }
  function scroll(destination, duration, snap, callback) {
    Components2.Scroll.scroll(destination, duration, snap, function() {
      var index = loop(Move2.toIndex(getPosition()));
      setIndex(omitEnd ? min(index, endIndex) : index);
      callback && callback();
    });
  }
  function parse(control) {
    var index = currIndex;
    if (isString(control)) {
      var _ref = control.match(/([+\-<>])(\d+)?/) || [], indicator = _ref[1], number = _ref[2];
      if (indicator === "+" || indicator === "-") {
        index = computeDestIndex(currIndex + +("" + indicator + (+number || 1)), currIndex);
      } else if (indicator === ">") {
        index = number ? toIndex(+number) : getNext(true);
      } else if (indicator === "<") {
        index = getPrev(true);
      }
    } else {
      index = isLoop ? control : clamp(control, 0, endIndex);
    }
    return index;
  }
  function getAdjacent(prev, destination) {
    var number = perMove || (hasFocus() ? 1 : perPage);
    var dest = computeDestIndex(currIndex + number * (prev ? -1 : 1), currIndex, !(perMove || hasFocus()));
    if (dest === -1 && isSlide) {
      if (!approximatelyEqual(getPosition(), getLimit(!prev), 1)) {
        return prev ? 0 : endIndex;
      }
    }
    return destination ? dest : loop(dest);
  }
  function computeDestIndex(dest, from, snapPage) {
    if (isEnough() || hasFocus()) {
      var index = computeMovableDestIndex(dest);
      if (index !== dest) {
        from = dest;
        dest = index;
        snapPage = false;
      }
      if (dest < 0 || dest > endIndex) {
        if (!perMove && (between(0, dest, from, true) || between(endIndex, from, dest, true))) {
          dest = toIndex(toPage(dest));
        } else {
          if (isLoop) {
            dest = snapPage ? dest < 0 ? -(slideCount % perPage || perPage) : slideCount : dest;
          } else if (options.rewind) {
            dest = dest < 0 ? endIndex : 0;
          } else {
            dest = -1;
          }
        }
      } else {
        if (snapPage && dest !== from) {
          dest = toIndex(toPage(from) + (dest < from ? -1 : 1));
        }
      }
    } else {
      dest = -1;
    }
    return dest;
  }
  function computeMovableDestIndex(dest) {
    if (isSlide && options.trimSpace === "move" && dest !== currIndex) {
      var position = getPosition();
      while (position === toPosition(dest, true) && between(dest, 0, Splide2.length - 1, !options.rewind)) {
        dest < currIndex ? --dest : ++dest;
      }
    }
    return dest;
  }
  function loop(index) {
    return isLoop ? (index + slideCount) % slideCount || 0 : index;
  }
  function getEnd() {
    var end = slideCount - (hasFocus() || isLoop && perMove ? 1 : perPage);
    while (omitEnd && end-- > 0) {
      if (toPosition(slideCount - 1, true) !== toPosition(end, true)) {
        end++;
        break;
      }
    }
    return clamp(end, 0, slideCount - 1);
  }
  function toIndex(page) {
    return clamp(hasFocus() ? page : perPage * page, 0, endIndex);
  }
  function toPage(index) {
    return hasFocus() ? min(index, endIndex) : floor((index >= endIndex ? slideCount - 1 : index) / perPage);
  }
  function toDest(destination) {
    var closest2 = Move2.toIndex(destination);
    return isSlide ? clamp(closest2, 0, endIndex) : closest2;
  }
  function setIndex(index) {
    if (index !== currIndex) {
      prevIndex = currIndex;
      currIndex = index;
    }
  }
  function getIndex(prev) {
    return prev ? prevIndex : currIndex;
  }
  function hasFocus() {
    return !isUndefined(options.focus) || options.isNavigation;
  }
  function isBusy() {
    return Splide2.state.is([MOVING, SCROLLING]) && !!options.waitForTransition;
  }
  return {
    mount,
    go,
    scroll,
    getNext,
    getPrev,
    getAdjacent,
    getEnd,
    setIndex,
    getIndex,
    toIndex,
    toPage,
    toDest,
    hasFocus,
    isBusy
  };
}
var XML_NAME_SPACE = "http://www.w3.org/2000/svg";
var PATH = "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z";
var SIZE = 40;
function Arrows(Splide2, Components2, options) {
  var event = EventInterface(Splide2);
  var on = event.on, bind = event.bind, emit = event.emit;
  var classes = options.classes, i18n = options.i18n;
  var Elements2 = Components2.Elements, Controller2 = Components2.Controller;
  var placeholder = Elements2.arrows, track = Elements2.track;
  var wrapper = placeholder;
  var prev = Elements2.prev;
  var next = Elements2.next;
  var created;
  var wrapperClasses;
  var arrows = {};
  function mount() {
    init();
    on(EVENT_UPDATED, remount);
  }
  function remount() {
    destroy();
    mount();
  }
  function init() {
    var enabled = options.arrows;
    if (enabled && !(prev && next)) {
      createArrows();
    }
    if (prev && next) {
      assign(arrows, {
        prev,
        next
      });
      display(wrapper, enabled ? "" : "none");
      addClass(wrapper, wrapperClasses = CLASS_ARROWS + "--" + options.direction);
      if (enabled) {
        listen();
        update();
        setAttribute([prev, next], ARIA_CONTROLS, track.id);
        emit(EVENT_ARROWS_MOUNTED, prev, next);
      }
    }
  }
  function destroy() {
    event.destroy();
    removeClass(wrapper, wrapperClasses);
    if (created) {
      remove(placeholder ? [prev, next] : wrapper);
      prev = next = null;
    } else {
      removeAttribute([prev, next], ALL_ATTRIBUTES);
    }
  }
  function listen() {
    on([EVENT_MOUNTED, EVENT_MOVED, EVENT_REFRESH, EVENT_SCROLLED, EVENT_END_INDEX_CHANGED], update);
    bind(next, "click", apply(go, ">"));
    bind(prev, "click", apply(go, "<"));
  }
  function go(control) {
    Controller2.go(control, true);
  }
  function createArrows() {
    wrapper = placeholder || create("div", classes.arrows);
    prev = createArrow(true);
    next = createArrow(false);
    created = true;
    append(wrapper, [prev, next]);
    !placeholder && before(wrapper, track);
  }
  function createArrow(prev2) {
    var arrow = '<button class="' + classes.arrow + " " + (prev2 ? classes.prev : classes.next) + '" type="button"><svg xmlns="' + XML_NAME_SPACE + '" viewBox="0 0 ' + SIZE + " " + SIZE + '" width="' + SIZE + '" height="' + SIZE + '" focusable="false"><path d="' + (options.arrowPath || PATH) + '" />';
    return parseHtml(arrow);
  }
  function update() {
    if (prev && next) {
      var index = Splide2.index;
      var prevIndex = Controller2.getPrev();
      var nextIndex = Controller2.getNext();
      var prevLabel = prevIndex > -1 && index < prevIndex ? i18n.last : i18n.prev;
      var nextLabel = nextIndex > -1 && index > nextIndex ? i18n.first : i18n.next;
      prev.disabled = prevIndex < 0;
      next.disabled = nextIndex < 0;
      setAttribute(prev, ARIA_LABEL, prevLabel);
      setAttribute(next, ARIA_LABEL, nextLabel);
      emit(EVENT_ARROWS_UPDATED, prev, next, prevIndex, nextIndex);
    }
  }
  return {
    arrows,
    mount,
    destroy,
    update
  };
}
var INTERVAL_DATA_ATTRIBUTE = DATA_ATTRIBUTE + "-interval";
function Autoplay(Splide2, Components2, options) {
  var _EventInterface6 = EventInterface(Splide2), on = _EventInterface6.on, bind = _EventInterface6.bind, emit = _EventInterface6.emit;
  var interval = RequestInterval(options.interval, Splide2.go.bind(Splide2, ">"), onAnimationFrame);
  var isPaused = interval.isPaused;
  var Elements2 = Components2.Elements, _Components2$Elements4 = Components2.Elements, root = _Components2$Elements4.root, toggle = _Components2$Elements4.toggle;
  var autoplay = options.autoplay;
  var hovered;
  var focused;
  var stopped = autoplay === "pause";
  function mount() {
    if (autoplay) {
      listen();
      toggle && setAttribute(toggle, ARIA_CONTROLS, Elements2.track.id);
      stopped || play();
      update();
    }
  }
  function listen() {
    if (options.pauseOnHover) {
      bind(root, "mouseenter mouseleave", function(e) {
        hovered = e.type === "mouseenter";
        autoToggle();
      });
    }
    if (options.pauseOnFocus) {
      bind(root, "focusin focusout", function(e) {
        focused = e.type === "focusin";
        autoToggle();
      });
    }
    if (toggle) {
      bind(toggle, "click", function() {
        stopped ? play() : pause(true);
      });
    }
    on([EVENT_MOVE, EVENT_SCROLL, EVENT_REFRESH], interval.rewind);
    on(EVENT_MOVE, onMove);
  }
  function play() {
    if (isPaused() && Components2.Slides.isEnough()) {
      interval.start(!options.resetProgress);
      focused = hovered = stopped = false;
      update();
      emit(EVENT_AUTOPLAY_PLAY);
    }
  }
  function pause(stop) {
    if (stop === void 0) {
      stop = true;
    }
    stopped = !!stop;
    update();
    if (!isPaused()) {
      interval.pause();
      emit(EVENT_AUTOPLAY_PAUSE);
    }
  }
  function autoToggle() {
    if (!stopped) {
      hovered || focused ? pause(false) : play();
    }
  }
  function update() {
    if (toggle) {
      toggleClass(toggle, CLASS_ACTIVE, !stopped);
      setAttribute(toggle, ARIA_LABEL, options.i18n[stopped ? "play" : "pause"]);
    }
  }
  function onAnimationFrame(rate) {
    var bar = Elements2.bar;
    bar && style(bar, "width", rate * 100 + "%");
    emit(EVENT_AUTOPLAY_PLAYING, rate);
  }
  function onMove(index) {
    var Slide2 = Components2.Slides.getAt(index);
    interval.set(Slide2 && +getAttribute(Slide2.slide, INTERVAL_DATA_ATTRIBUTE) || options.interval);
  }
  return {
    mount,
    destroy: interval.cancel,
    play,
    pause,
    isPaused
  };
}
function Cover(Splide2, Components2, options) {
  var _EventInterface7 = EventInterface(Splide2), on = _EventInterface7.on;
  function mount() {
    if (options.cover) {
      on(EVENT_LAZYLOAD_LOADED, apply(toggle, true));
      on([EVENT_MOUNTED, EVENT_UPDATED, EVENT_REFRESH], apply(cover, true));
    }
  }
  function cover(cover2) {
    Components2.Slides.forEach(function(Slide2) {
      var img = child(Slide2.container || Slide2.slide, "img");
      if (img && img.src) {
        toggle(cover2, img, Slide2);
      }
    });
  }
  function toggle(cover2, img, Slide2) {
    Slide2.style("background", cover2 ? 'center/cover no-repeat url("' + img.src + '")' : "", true);
    display(img, cover2 ? "none" : "");
  }
  return {
    mount,
    destroy: apply(cover, false)
  };
}
var BOUNCE_DIFF_THRESHOLD = 10;
var BOUNCE_DURATION = 600;
var FRICTION_FACTOR = 0.6;
var BASE_VELOCITY = 1.5;
var MIN_DURATION = 800;
function Scroll(Splide2, Components2, options) {
  var _EventInterface8 = EventInterface(Splide2), on = _EventInterface8.on, emit = _EventInterface8.emit;
  var set = Splide2.state.set;
  var Move2 = Components2.Move;
  var getPosition = Move2.getPosition, getLimit = Move2.getLimit, exceededLimit = Move2.exceededLimit, translate = Move2.translate;
  var isSlide = Splide2.is(SLIDE);
  var interval;
  var callback;
  var friction = 1;
  function mount() {
    on(EVENT_MOVE, clear);
    on([EVENT_UPDATED, EVENT_REFRESH], cancel);
  }
  function scroll(destination, duration, snap, onScrolled, noConstrain) {
    var from = getPosition();
    clear();
    if (snap && (!isSlide || !exceededLimit())) {
      var size = Components2.Layout.sliderSize();
      var offset = sign(destination) * size * floor(abs(destination) / size) || 0;
      destination = Move2.toPosition(Components2.Controller.toDest(destination % size)) + offset;
    }
    var noDistance = approximatelyEqual(from, destination, 1);
    friction = 1;
    duration = noDistance ? 0 : duration || max(abs(destination - from) / BASE_VELOCITY, MIN_DURATION);
    callback = onScrolled;
    interval = RequestInterval(duration, onEnd, apply(update, from, destination, noConstrain), 1);
    set(SCROLLING);
    emit(EVENT_SCROLL);
    interval.start();
  }
  function onEnd() {
    set(IDLE);
    callback && callback();
    emit(EVENT_SCROLLED);
  }
  function update(from, to, noConstrain, rate) {
    var position = getPosition();
    var target = from + (to - from) * easing(rate);
    var diff = (target - position) * friction;
    translate(position + diff);
    if (isSlide && !noConstrain && exceededLimit()) {
      friction *= FRICTION_FACTOR;
      if (abs(diff) < BOUNCE_DIFF_THRESHOLD) {
        scroll(getLimit(exceededLimit(true)), BOUNCE_DURATION, false, callback, true);
      }
    }
  }
  function clear() {
    if (interval) {
      interval.cancel();
    }
  }
  function cancel() {
    if (interval && !interval.isPaused()) {
      clear();
      onEnd();
    }
  }
  function easing(t) {
    var easingFunc = options.easingFunc;
    return easingFunc ? easingFunc(t) : 1 - Math.pow(1 - t, 4);
  }
  return {
    mount,
    destroy: clear,
    scroll,
    cancel
  };
}
var SCROLL_LISTENER_OPTIONS = {
  passive: false,
  capture: true
};
function Drag(Splide2, Components2, options) {
  var _EventInterface9 = EventInterface(Splide2), on = _EventInterface9.on, emit = _EventInterface9.emit, bind = _EventInterface9.bind, unbind = _EventInterface9.unbind;
  var state = Splide2.state;
  var Move2 = Components2.Move, Scroll2 = Components2.Scroll, Controller2 = Components2.Controller, track = Components2.Elements.track, reduce = Components2.Media.reduce;
  var _Components2$Directio2 = Components2.Direction, resolve = _Components2$Directio2.resolve, orient = _Components2$Directio2.orient;
  var getPosition = Move2.getPosition, exceededLimit = Move2.exceededLimit;
  var basePosition;
  var baseEvent;
  var prevBaseEvent;
  var isFree;
  var dragging;
  var exceeded = false;
  var clickPrevented;
  var disabled;
  var target;
  function mount() {
    bind(track, POINTER_MOVE_EVENTS, noop, SCROLL_LISTENER_OPTIONS);
    bind(track, POINTER_UP_EVENTS, noop, SCROLL_LISTENER_OPTIONS);
    bind(track, POINTER_DOWN_EVENTS, onPointerDown, SCROLL_LISTENER_OPTIONS);
    bind(track, "click", onClick, {
      capture: true
    });
    bind(track, "dragstart", prevent);
    on([EVENT_MOUNTED, EVENT_UPDATED], init);
  }
  function init() {
    var drag = options.drag;
    disable(!drag);
    isFree = drag === "free";
  }
  function onPointerDown(e) {
    clickPrevented = false;
    if (!disabled) {
      var isTouch = isTouchEvent(e);
      if (isDraggable(e.target) && (isTouch || !e.button)) {
        if (!Controller2.isBusy()) {
          target = isTouch ? track : window;
          dragging = state.is([MOVING, SCROLLING]);
          prevBaseEvent = null;
          bind(target, POINTER_MOVE_EVENTS, onPointerMove, SCROLL_LISTENER_OPTIONS);
          bind(target, POINTER_UP_EVENTS, onPointerUp, SCROLL_LISTENER_OPTIONS);
          Move2.cancel();
          Scroll2.cancel();
          save(e);
        } else {
          prevent(e, true);
        }
      }
    }
  }
  function onPointerMove(e) {
    if (!state.is(DRAGGING)) {
      state.set(DRAGGING);
      emit(EVENT_DRAG);
    }
    if (e.cancelable) {
      if (dragging) {
        Move2.translate(basePosition + constrain(diffCoord(e)));
        var expired = diffTime(e) > LOG_INTERVAL;
        var hasExceeded = exceeded !== (exceeded = exceededLimit());
        if (expired || hasExceeded) {
          save(e);
        }
        clickPrevented = true;
        emit(EVENT_DRAGGING);
        prevent(e);
      } else if (isSliderDirection(e)) {
        dragging = shouldStart(e);
        prevent(e);
      }
    }
  }
  function onPointerUp(e) {
    if (state.is(DRAGGING)) {
      state.set(IDLE);
      emit(EVENT_DRAGGED);
    }
    if (dragging) {
      move(e);
      prevent(e);
    }
    unbind(target, POINTER_MOVE_EVENTS, onPointerMove);
    unbind(target, POINTER_UP_EVENTS, onPointerUp);
    dragging = false;
  }
  function onClick(e) {
    if (!disabled && clickPrevented) {
      prevent(e, true);
    }
  }
  function save(e) {
    prevBaseEvent = baseEvent;
    baseEvent = e;
    basePosition = getPosition();
  }
  function move(e) {
    var velocity = computeVelocity(e);
    var destination = computeDestination(velocity);
    var rewind = options.rewind && options.rewindByDrag;
    reduce(false);
    if (isFree) {
      Controller2.scroll(destination, 0, options.snap);
    } else if (Splide2.is(FADE)) {
      Controller2.go(orient(sign(velocity)) < 0 ? rewind ? "<" : "-" : rewind ? ">" : "+");
    } else if (Splide2.is(SLIDE) && exceeded && rewind) {
      Controller2.go(exceededLimit(true) ? ">" : "<");
    } else {
      Controller2.go(Controller2.toDest(destination), true);
    }
    reduce(true);
  }
  function shouldStart(e) {
    var thresholds = options.dragMinThreshold;
    var isObj = isObject(thresholds);
    var mouse = isObj && thresholds.mouse || 0;
    var touch = (isObj ? thresholds.touch : +thresholds) || 10;
    return abs(diffCoord(e)) > (isTouchEvent(e) ? touch : mouse);
  }
  function isSliderDirection(e) {
    return abs(diffCoord(e)) > abs(diffCoord(e, true));
  }
  function computeVelocity(e) {
    if (Splide2.is(LOOP) || !exceeded) {
      var time = diffTime(e);
      if (time && time < LOG_INTERVAL) {
        return diffCoord(e) / time;
      }
    }
    return 0;
  }
  function computeDestination(velocity) {
    return getPosition() + sign(velocity) * min(abs(velocity) * (options.flickPower || 600), isFree ? Infinity : Components2.Layout.listSize() * (options.flickMaxPages || 1));
  }
  function diffCoord(e, orthogonal) {
    return coordOf(e, orthogonal) - coordOf(getBaseEvent(e), orthogonal);
  }
  function diffTime(e) {
    return timeOf(e) - timeOf(getBaseEvent(e));
  }
  function getBaseEvent(e) {
    return baseEvent === e && prevBaseEvent || baseEvent;
  }
  function coordOf(e, orthogonal) {
    return (isTouchEvent(e) ? e.changedTouches[0] : e)["page" + resolve(orthogonal ? "Y" : "X")];
  }
  function constrain(diff) {
    return diff / (exceeded && Splide2.is(SLIDE) ? FRICTION : 1);
  }
  function isDraggable(target2) {
    var noDrag = options.noDrag;
    return !matches(target2, "." + CLASS_PAGINATION_PAGE + ", ." + CLASS_ARROW) && (!noDrag || !matches(target2, noDrag));
  }
  function isTouchEvent(e) {
    return typeof TouchEvent !== "undefined" && e instanceof TouchEvent;
  }
  function isDragging() {
    return dragging;
  }
  function disable(value) {
    disabled = value;
  }
  return {
    mount,
    disable,
    isDragging
  };
}
var NORMALIZATION_MAP = {
  Spacebar: " ",
  Right: ARROW_RIGHT,
  Left: ARROW_LEFT,
  Up: ARROW_UP,
  Down: ARROW_DOWN
};
function normalizeKey(key) {
  key = isString(key) ? key : key.key;
  return NORMALIZATION_MAP[key] || key;
}
var KEYBOARD_EVENT = "keydown";
function Keyboard(Splide2, Components2, options) {
  var _EventInterface10 = EventInterface(Splide2), on = _EventInterface10.on, bind = _EventInterface10.bind, unbind = _EventInterface10.unbind;
  var root = Splide2.root;
  var resolve = Components2.Direction.resolve;
  var target;
  var disabled;
  function mount() {
    init();
    on(EVENT_UPDATED, destroy);
    on(EVENT_UPDATED, init);
    on(EVENT_MOVE, onMove);
  }
  function init() {
    var keyboard = options.keyboard;
    if (keyboard) {
      target = keyboard === "global" ? window : root;
      bind(target, KEYBOARD_EVENT, onKeydown);
    }
  }
  function destroy() {
    unbind(target, KEYBOARD_EVENT);
  }
  function disable(value) {
    disabled = value;
  }
  function onMove() {
    var _disabled = disabled;
    disabled = true;
    nextTick(function() {
      disabled = _disabled;
    });
  }
  function onKeydown(e) {
    if (!disabled) {
      var key = normalizeKey(e);
      if (key === resolve(ARROW_LEFT)) {
        Splide2.go("<");
      } else if (key === resolve(ARROW_RIGHT)) {
        Splide2.go(">");
      }
    }
  }
  return {
    mount,
    destroy,
    disable
  };
}
var SRC_DATA_ATTRIBUTE = DATA_ATTRIBUTE + "-lazy";
var SRCSET_DATA_ATTRIBUTE = SRC_DATA_ATTRIBUTE + "-srcset";
var IMAGE_SELECTOR = "[" + SRC_DATA_ATTRIBUTE + "], [" + SRCSET_DATA_ATTRIBUTE + "]";
function LazyLoad(Splide2, Components2, options) {
  var _EventInterface11 = EventInterface(Splide2), on = _EventInterface11.on, off = _EventInterface11.off, bind = _EventInterface11.bind, emit = _EventInterface11.emit;
  var isSequential = options.lazyLoad === "sequential";
  var events = [EVENT_MOVED, EVENT_SCROLLED];
  var entries = [];
  function mount() {
    if (options.lazyLoad) {
      init();
      on(EVENT_REFRESH, init);
    }
  }
  function init() {
    empty(entries);
    register();
    if (isSequential) {
      loadNext();
    } else {
      off(events);
      on(events, check);
      check();
    }
  }
  function register() {
    Components2.Slides.forEach(function(Slide2) {
      queryAll(Slide2.slide, IMAGE_SELECTOR).forEach(function(img) {
        var src = getAttribute(img, SRC_DATA_ATTRIBUTE);
        var srcset = getAttribute(img, SRCSET_DATA_ATTRIBUTE);
        if (src !== img.src || srcset !== img.srcset) {
          var className = options.classes.spinner;
          var parent = img.parentElement;
          var spinner = child(parent, "." + className) || create("span", className, parent);
          entries.push([img, Slide2, spinner]);
          img.src || display(img, "none");
        }
      });
    });
  }
  function check() {
    entries = entries.filter(function(data) {
      var distance = options.perPage * ((options.preloadPages || 1) + 1) - 1;
      return data[1].isWithin(Splide2.index, distance) ? load(data) : true;
    });
    entries.length || off(events);
  }
  function load(data) {
    var img = data[0];
    addClass(data[1].slide, CLASS_LOADING);
    bind(img, "load error", apply(onLoad, data));
    setAttribute(img, "src", getAttribute(img, SRC_DATA_ATTRIBUTE));
    setAttribute(img, "srcset", getAttribute(img, SRCSET_DATA_ATTRIBUTE));
    removeAttribute(img, SRC_DATA_ATTRIBUTE);
    removeAttribute(img, SRCSET_DATA_ATTRIBUTE);
  }
  function onLoad(data, e) {
    var img = data[0], Slide2 = data[1];
    removeClass(Slide2.slide, CLASS_LOADING);
    if (e.type !== "error") {
      remove(data[2]);
      display(img, "");
      emit(EVENT_LAZYLOAD_LOADED, img, Slide2);
      emit(EVENT_RESIZE);
    }
    isSequential && loadNext();
  }
  function loadNext() {
    entries.length && load(entries.shift());
  }
  return {
    mount,
    destroy: apply(empty, entries),
    check
  };
}
function Pagination(Splide2, Components2, options) {
  var event = EventInterface(Splide2);
  var on = event.on, emit = event.emit, bind = event.bind;
  var Slides2 = Components2.Slides, Elements2 = Components2.Elements, Controller2 = Components2.Controller;
  var hasFocus = Controller2.hasFocus, getIndex = Controller2.getIndex, go = Controller2.go;
  var resolve = Components2.Direction.resolve;
  var placeholder = Elements2.pagination;
  var items = [];
  var list;
  var paginationClasses;
  function mount() {
    destroy();
    on([EVENT_UPDATED, EVENT_REFRESH, EVENT_END_INDEX_CHANGED], mount);
    var enabled = options.pagination;
    placeholder && display(placeholder, enabled ? "" : "none");
    if (enabled) {
      on([EVENT_MOVE, EVENT_SCROLL, EVENT_SCROLLED], update);
      createPagination();
      update();
      emit(EVENT_PAGINATION_MOUNTED, {
        list,
        items
      }, getAt(Splide2.index));
    }
  }
  function destroy() {
    if (list) {
      remove(placeholder ? slice(list.children) : list);
      removeClass(list, paginationClasses);
      empty(items);
      list = null;
    }
    event.destroy();
  }
  function createPagination() {
    var length = Splide2.length;
    var classes = options.classes, i18n = options.i18n, perPage = options.perPage;
    var max2 = hasFocus() ? Controller2.getEnd() + 1 : ceil(length / perPage);
    list = placeholder || create("ul", classes.pagination, Elements2.track.parentElement);
    addClass(list, paginationClasses = CLASS_PAGINATION + "--" + getDirection());
    setAttribute(list, ROLE, "tablist");
    setAttribute(list, ARIA_LABEL, i18n.select);
    setAttribute(list, ARIA_ORIENTATION, getDirection() === TTB ? "vertical" : "");
    for (var i = 0; i < max2; i++) {
      var li = create("li", null, list);
      var button = create("button", {
        class: classes.page,
        type: "button"
      }, li);
      var controls = Slides2.getIn(i).map(function(Slide2) {
        return Slide2.slide.id;
      });
      var text = !hasFocus() && perPage > 1 ? i18n.pageX : i18n.slideX;
      bind(button, "click", apply(onClick, i));
      if (options.paginationKeyboard) {
        bind(button, "keydown", apply(onKeydown, i));
      }
      setAttribute(li, ROLE, "presentation");
      setAttribute(button, ROLE, "tab");
      setAttribute(button, ARIA_CONTROLS, controls.join(" "));
      setAttribute(button, ARIA_LABEL, format(text, i + 1));
      setAttribute(button, TAB_INDEX, -1);
      items.push({
        li,
        button,
        page: i
      });
    }
  }
  function onClick(page) {
    go(">" + page, true);
  }
  function onKeydown(page, e) {
    var length = items.length;
    var key = normalizeKey(e);
    var dir = getDirection();
    var nextPage = -1;
    if (key === resolve(ARROW_RIGHT, false, dir)) {
      nextPage = ++page % length;
    } else if (key === resolve(ARROW_LEFT, false, dir)) {
      nextPage = (--page + length) % length;
    } else if (key === "Home") {
      nextPage = 0;
    } else if (key === "End") {
      nextPage = length - 1;
    }
    var item = items[nextPage];
    if (item) {
      focus(item.button);
      go(">" + nextPage);
      prevent(e, true);
    }
  }
  function getDirection() {
    return options.paginationDirection || options.direction;
  }
  function getAt(index) {
    return items[Controller2.toPage(index)];
  }
  function update() {
    var prev = getAt(getIndex(true));
    var curr = getAt(getIndex());
    if (prev) {
      var button = prev.button;
      removeClass(button, CLASS_ACTIVE);
      removeAttribute(button, ARIA_SELECTED);
      setAttribute(button, TAB_INDEX, -1);
    }
    if (curr) {
      var _button = curr.button;
      addClass(_button, CLASS_ACTIVE);
      setAttribute(_button, ARIA_SELECTED, true);
      setAttribute(_button, TAB_INDEX, "");
    }
    emit(EVENT_PAGINATION_UPDATED, {
      list,
      items
    }, prev, curr);
  }
  return {
    items,
    mount,
    destroy,
    getAt,
    update
  };
}
var TRIGGER_KEYS = [" ", "Enter"];
function Sync(Splide2, Components2, options) {
  var isNavigation = options.isNavigation, slideFocus = options.slideFocus;
  var events = [];
  function mount() {
    Splide2.splides.forEach(function(target) {
      if (!target.isParent) {
        sync(Splide2, target.splide);
        sync(target.splide, Splide2);
      }
    });
    if (isNavigation) {
      navigate();
    }
  }
  function destroy() {
    events.forEach(function(event) {
      event.destroy();
    });
    empty(events);
  }
  function remount() {
    destroy();
    mount();
  }
  function sync(splide, target) {
    var event = EventInterface(splide);
    event.on(EVENT_MOVE, function(index, prev, dest) {
      target.go(target.is(LOOP) ? dest : index);
    });
    events.push(event);
  }
  function navigate() {
    var event = EventInterface(Splide2);
    var on = event.on;
    on(EVENT_CLICK, onClick);
    on(EVENT_SLIDE_KEYDOWN, onKeydown);
    on([EVENT_MOUNTED, EVENT_UPDATED], update);
    events.push(event);
    event.emit(EVENT_NAVIGATION_MOUNTED, Splide2.splides);
  }
  function update() {
    setAttribute(Components2.Elements.list, ARIA_ORIENTATION, options.direction === TTB ? "vertical" : "");
  }
  function onClick(Slide2) {
    Splide2.go(Slide2.index);
  }
  function onKeydown(Slide2, e) {
    if (includes(TRIGGER_KEYS, normalizeKey(e))) {
      onClick(Slide2);
      prevent(e);
    }
  }
  return {
    setup: apply(Components2.Media.set, {
      slideFocus: isUndefined(slideFocus) ? isNavigation : slideFocus
    }, true),
    mount,
    destroy,
    remount
  };
}
function Wheel(Splide2, Components2, options) {
  var _EventInterface12 = EventInterface(Splide2), bind = _EventInterface12.bind;
  var lastTime = 0;
  function mount() {
    if (options.wheel) {
      bind(Components2.Elements.track, "wheel", onWheel, SCROLL_LISTENER_OPTIONS);
    }
  }
  function onWheel(e) {
    if (e.cancelable) {
      var deltaY = e.deltaY;
      var backwards = deltaY < 0;
      var timeStamp = timeOf(e);
      var _min = options.wheelMinThreshold || 0;
      var sleep = options.wheelSleep || 0;
      if (abs(deltaY) > _min && timeStamp - lastTime > sleep) {
        Splide2.go(backwards ? "<" : ">");
        lastTime = timeStamp;
      }
      shouldPrevent(backwards) && prevent(e);
    }
  }
  function shouldPrevent(backwards) {
    return !options.releaseWheel || Splide2.state.is(MOVING) || Components2.Controller.getAdjacent(backwards) !== -1;
  }
  return {
    mount
  };
}
var SR_REMOVAL_DELAY = 90;
function Live(Splide2, Components2, options) {
  var _EventInterface13 = EventInterface(Splide2), on = _EventInterface13.on;
  var track = Components2.Elements.track;
  var enabled = options.live && !options.isNavigation;
  var sr = create("span", CLASS_SR);
  var interval = RequestInterval(SR_REMOVAL_DELAY, apply(toggle, false));
  function mount() {
    if (enabled) {
      disable(!Components2.Autoplay.isPaused());
      setAttribute(track, ARIA_ATOMIC, true);
      sr.textContent = "…";
      on(EVENT_AUTOPLAY_PLAY, apply(disable, true));
      on(EVENT_AUTOPLAY_PAUSE, apply(disable, false));
      on([EVENT_MOVED, EVENT_SCROLLED], apply(toggle, true));
    }
  }
  function toggle(active) {
    setAttribute(track, ARIA_BUSY, active);
    if (active) {
      append(track, sr);
      interval.start();
    } else {
      remove(sr);
      interval.cancel();
    }
  }
  function destroy() {
    removeAttribute(track, [ARIA_LIVE, ARIA_ATOMIC, ARIA_BUSY]);
    remove(sr);
  }
  function disable(disabled) {
    if (enabled) {
      setAttribute(track, ARIA_LIVE, disabled ? "off" : "polite");
    }
  }
  return {
    mount,
    disable,
    destroy
  };
}
var ComponentConstructors = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  Media,
  Direction,
  Elements,
  Slides,
  Layout,
  Clones,
  Move,
  Controller,
  Arrows,
  Autoplay,
  Cover,
  Scroll,
  Drag,
  Keyboard,
  LazyLoad,
  Pagination,
  Sync,
  Wheel,
  Live
});
var I18N = {
  prev: "Previous slide",
  next: "Next slide",
  first: "Go to first slide",
  last: "Go to last slide",
  slideX: "Go to slide %s",
  pageX: "Go to page %s",
  play: "Start autoplay",
  pause: "Pause autoplay",
  carousel: "carousel",
  slide: "slide",
  select: "Select a slide to show",
  slideLabel: "%s of %s"
};
var DEFAULTS = {
  type: "slide",
  role: "region",
  speed: 400,
  perPage: 1,
  cloneStatus: true,
  arrows: true,
  pagination: true,
  paginationKeyboard: true,
  interval: 5e3,
  pauseOnHover: true,
  pauseOnFocus: true,
  resetProgress: true,
  easing: "cubic-bezier(0.25, 1, 0.5, 1)",
  drag: true,
  direction: "ltr",
  trimSpace: true,
  focusableNodes: "a, button, textarea, input, select, iframe",
  live: true,
  classes: CLASSES,
  i18n: I18N,
  reducedMotion: {
    speed: 0,
    rewindSpeed: 0,
    autoplay: "pause"
  }
};
function Fade(Splide2, Components2, options) {
  var Slides2 = Components2.Slides;
  function mount() {
    EventInterface(Splide2).on([EVENT_MOUNTED, EVENT_REFRESH], init);
  }
  function init() {
    Slides2.forEach(function(Slide2) {
      Slide2.style("transform", "translateX(-" + 100 * Slide2.index + "%)");
    });
  }
  function start(index, done) {
    Slides2.style("transition", "opacity " + options.speed + "ms " + options.easing);
    nextTick(done);
  }
  return {
    mount,
    start,
    cancel: noop
  };
}
function Slide(Splide2, Components2, options) {
  var Move2 = Components2.Move, Controller2 = Components2.Controller, Scroll2 = Components2.Scroll;
  var list = Components2.Elements.list;
  var transition = apply(style, list, "transition");
  var endCallback;
  function mount() {
    EventInterface(Splide2).bind(list, "transitionend", function(e) {
      if (e.target === list && endCallback) {
        cancel();
        endCallback();
      }
    });
  }
  function start(index, done) {
    var destination = Move2.toPosition(index, true);
    var position = Move2.getPosition();
    var speed = getSpeed(index);
    if (abs(destination - position) >= 1 && speed >= 1) {
      if (options.useScroll) {
        Scroll2.scroll(destination, speed, false, done);
      } else {
        transition("transform " + speed + "ms " + options.easing);
        Move2.translate(destination, true);
        endCallback = done;
      }
    } else {
      Move2.jump(index);
      done();
    }
  }
  function cancel() {
    transition("");
    Scroll2.cancel();
  }
  function getSpeed(index) {
    var rewindSpeed = options.rewindSpeed;
    if (Splide2.is(SLIDE) && rewindSpeed) {
      var prev = Controller2.getIndex(true);
      var end = Controller2.getEnd();
      if (prev === 0 && index >= end || prev >= end && index === 0) {
        return rewindSpeed;
      }
    }
    return options.speed;
  }
  return {
    mount,
    start,
    cancel
  };
}
var _Splide = /* @__PURE__ */ function() {
  function _Splide2(target, options) {
    this.event = EventInterface();
    this.Components = {};
    this.state = State(CREATED);
    this.splides = [];
    this._o = {};
    this._E = {};
    var root = isString(target) ? query(document, target) : target;
    assert(root, root + " is invalid.");
    this.root = root;
    options = merge({
      label: getAttribute(root, ARIA_LABEL) || "",
      labelledby: getAttribute(root, ARIA_LABELLEDBY) || ""
    }, DEFAULTS, _Splide2.defaults, options || {});
    try {
      merge(options, JSON.parse(getAttribute(root, DATA_ATTRIBUTE)));
    } catch (e) {
      assert(false, "Invalid JSON");
    }
    this._o = Object.create(merge({}, options));
  }
  var _proto = _Splide2.prototype;
  _proto.mount = function mount(Extensions, Transition) {
    var _this = this;
    var state = this.state, Components2 = this.Components;
    assert(state.is([CREATED, DESTROYED]), "Already mounted!");
    state.set(CREATED);
    this._C = Components2;
    this._T = Transition || this._T || (this.is(FADE) ? Fade : Slide);
    this._E = Extensions || this._E;
    var Constructors = assign({}, ComponentConstructors, this._E, {
      Transition: this._T
    });
    forOwn(Constructors, function(Component, key) {
      var component = Component(_this, Components2, _this._o);
      Components2[key] = component;
      component.setup && component.setup();
    });
    forOwn(Components2, function(component) {
      component.mount && component.mount();
    });
    this.emit(EVENT_MOUNTED);
    addClass(this.root, CLASS_INITIALIZED);
    state.set(IDLE);
    this.emit(EVENT_READY);
    return this;
  };
  _proto.sync = function sync(splide) {
    this.splides.push({
      splide
    });
    splide.splides.push({
      splide: this,
      isParent: true
    });
    if (this.state.is(IDLE)) {
      this._C.Sync.remount();
      splide.Components.Sync.remount();
    }
    return this;
  };
  _proto.go = function go(control) {
    this._C.Controller.go(control);
    return this;
  };
  _proto.on = function on(events, callback) {
    this.event.on(events, callback);
    return this;
  };
  _proto.off = function off(events) {
    this.event.off(events);
    return this;
  };
  _proto.emit = function emit(event) {
    var _this$event;
    (_this$event = this.event).emit.apply(_this$event, [event].concat(slice(arguments, 1)));
    return this;
  };
  _proto.add = function add(slides, index) {
    this._C.Slides.add(slides, index);
    return this;
  };
  _proto.remove = function remove2(matcher) {
    this._C.Slides.remove(matcher);
    return this;
  };
  _proto.is = function is(type) {
    return this._o.type === type;
  };
  _proto.refresh = function refresh() {
    this.emit(EVENT_REFRESH);
    return this;
  };
  _proto.destroy = function destroy(completely) {
    if (completely === void 0) {
      completely = true;
    }
    var event = this.event, state = this.state;
    if (state.is(CREATED)) {
      EventInterface(this).on(EVENT_READY, this.destroy.bind(this, completely));
    } else {
      forOwn(this._C, function(component) {
        component.destroy && component.destroy(completely);
      }, true);
      event.emit(EVENT_DESTROY);
      event.destroy();
      completely && empty(this.splides);
      state.set(DESTROYED);
    }
    return this;
  };
  _createClass(_Splide2, [{
    key: "options",
    get: function get() {
      return this._o;
    },
    set: function set(options) {
      this._C.Media.set(options, true, true);
    }
  }, {
    key: "length",
    get: function get() {
      return this._C.Slides.getLength(true);
    }
  }, {
    key: "index",
    get: function get() {
      return this._C.Controller.getIndex();
    }
  }]);
  return _Splide2;
}();
var Splide = _Splide;
Splide.defaults = {};
Splide.STATES = STATES;
function enhanceSplideAccessibility(el, index) {
  if (!el) return;
  if (!el.hasAttribute("tabindex")) el.setAttribute("tabindex", "0");
  if (!el.hasAttribute("role")) el.setAttribute("role", "region");
  if (!el.hasAttribute("aria-roledescription")) el.setAttribute("aria-roledescription", "carousel");
  const heading = el.closest(".products-carousel, .centered-slider, .double-blocks, .shopify-section")?.querySelector("h1, h2, h3, h4, h5, h6");
  if (heading) {
    if (!heading.id) heading.id = `splide-heading-${index + 1}`;
    if (!el.hasAttribute("aria-labelledby")) el.setAttribute("aria-labelledby", heading.id);
  }
}
document.querySelectorAll(".splide.js-double-blocks-slider").forEach((el, index) => {
  enhanceSplideAccessibility(el, index);
  new Splide(el, {
    type: "loop",
    keyboard: true
  }).mount();
});
document.querySelectorAll(".splide.js-double-blocks-slider-2").forEach((el, index) => {
  enhanceSplideAccessibility(el, index + 20);
  new Splide(el, {
    type: "loop",
    keyboard: true
  }).mount();
});

document.querySelectorAll(".splide.js-centered-slider").forEach((el, index) => {
  enhanceSplideAccessibility(el, index + 40);
  let splide = new Splide(el, {
    type: "loop",
    arrows: false,
    pagination: false,
    focus: "center",
    drag: "free",
    keyboard: true
  });
  splide.mount();
});
document.querySelectorAll(".splide.js-products-slider").forEach((el, index) => {
  enhanceSplideAccessibility(el, index + 60);
  let splide = new Splide(el, {
    arrows: false,
    pagination: false,
    autoWidth: true,
    type: "loop",
    keyboard: true,
    gap: "3rem",
    breakpoints: {
      640: {
        gap: "1.4rem"
      }
    }
  });
  splide.mount();
});
document.querySelectorAll(".splide.js-products-slider-2").forEach((el, index) => {
  enhanceSplideAccessibility(el, index + 80);
  let splide = new Splide(el, {
    arrows: false,
    pagination: false,
    autoWidth: true,
    type: "loop",
    keyboard: true,
    gap: "3rem",
    breakpoints: {
      640: {
        gap: "1.4rem"
      }
    }
  });
  splide.mount();
});
if (document.querySelector(".color-swatch")) {
  document.querySelectorAll(".color-swatch").forEach((swatch, index) => {
    swatch.addEventListener("click", function() {
      document.querySelectorAll(".color-swatch").forEach((s) => s.classList.remove("is-active"));
      swatch.classList.add("is-active");
      const swatchOutput = document.querySelector(".color-swatches__output");
      if (swatchOutput && swatch.dataset.color) {
        swatchOutput.textContent = swatch.dataset.color;
      }
    });
  });
}
function initColorSwatchSliders() {
  document.querySelectorAll(".color-swatches").forEach((swatches) => {
    const list = swatches.querySelector(".color-swatches__list");
    const track = list?.querySelector("ul");
    const items = track ? Array.from(track.querySelectorAll("li")) : [];
    const hasImageSwatches = Boolean(track?.querySelector(".color-swatch__img"));

    if (!list || !track || !hasImageSwatches) {
      swatches.classList.remove("color-swatches--slider");
      swatches.querySelector(".color-swatches__dots")?.remove();
      return;
    }

    swatches.classList.remove("color-swatches--slider");
    const totalItemsWidth = items.reduce((total, item) => total + item.getBoundingClientRect().width, 0);
    const needsSlider = totalItemsWidth > list.clientWidth + 1;

    if (!needsSlider) {
      swatches.querySelector(".color-swatches__dots")?.remove();
      return;
    }

    swatches.classList.add("color-swatches--slider");

    let dots = swatches.querySelector(".color-swatches__dots");
    if (!dots) {
      dots = document.createElement("div");
      dots.className = "color-swatches__dots";
      swatches.appendChild(dots);
    }

    const pageCount = Math.max(1, Math.ceil(totalItemsWidth / Math.max(list.clientWidth, 1)));
    if (dots.children.length !== pageCount) {
      dots.innerHTML = "";
      for (let index = 0; index < pageCount; index += 1) {
        const dot = document.createElement("button");
        dot.type = "button";
        dot.className = "color-swatches__dot";
        dot.setAttribute("aria-label", `Go to color swatch slide ${index + 1}`);
        dot.addEventListener("click", () => {
          const maxScrollLeft = list.scrollWidth - list.clientWidth;
          list.scrollTo({
            left: Math.min(index * list.clientWidth, maxScrollLeft),
            behavior: "smooth"
          });
        });
        dots.appendChild(dot);
      }
    }

    const setActiveDot = () => {
      const maxScrollLeft = Math.max(list.scrollWidth - list.clientWidth, 1);
      const scrollProgress = list.scrollLeft / maxScrollLeft;
      const pageIndex = Math.min(pageCount - 1, Math.round(scrollProgress * (pageCount - 1)));
      dots.querySelectorAll(".color-swatches__dot").forEach((dot, index) => {
        const isActive = index === pageIndex;
        dot.classList.toggle("is-active", isActive);
        dot.classList.toggle("active", isActive);
        dot.setAttribute("aria-current", isActive ? "true" : "false");
      });
    };
    list.colorSwatchSetActiveDot = setActiveDot;

    if (!list.dataset.colorSwatchSliderInit) {
      list.dataset.colorSwatchSliderInit = "true";
      let scrollFrame;
      list.addEventListener("scroll", () => {
        window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(() => {
          if (list.colorSwatchSetActiveDot) {
            list.colorSwatchSetActiveDot();
          }
        });
      });
    }

    setActiveDot();
  });
}
initColorSwatchSliders();
let colorSwatchResizeTimer;
window.addEventListener("resize", () => {
  window.clearTimeout(colorSwatchResizeTimer);
  colorSwatchResizeTimer = window.setTimeout(initColorSwatchSliders, 150);
});
window.addEventListener("scroll", function() {
  let images = document.querySelectorAll(".js-indicator-image");
  let dots = document.querySelectorAll(".js-indicator-dot");
  let activeIndex = 0;
  if (images.length && dots.length) {
    const productSection = document.querySelector(".js-product-main-section");
    const imageIndicator = document.querySelector(".images-indicator");
    const productSectionRect = productSection.getBoundingClientRect();
    if (productSectionRect.bottom - 300 < 0 || productSectionRect.top > window.innerHeight) {
      imageIndicator.classList.add("hide");
    } else {
      imageIndicator.classList.remove("hide");
    }
    images.forEach((image, index) => {
      let imageTop = image.getBoundingClientRect().top;
      if (imageTop < window.innerHeight / 2) {
        activeIndex = index;
      }
    });
    dots.forEach((dot, index) => {
      if (index === activeIndex) {
        dot.classList.add("active");
      } else {
        dot.classList.remove("active");
      }
    });
  }
});
window.addEventListener("scroll", function() {
  const header = document.querySelector(".js-header");
  if (!header)
    return;
  if (window.scrollY <= 0) {
    header.classList.remove("is-white");
  } else {
    header.classList.add("is-white");
  }
});
const filters = document.querySelector(".js-filters");
const filtersMobile = document.querySelector(".js-filters-mobile");
if (filters) {
  const btns = document.querySelectorAll(".js-filters-trigger");
  btns.forEach((btn) => {
    btn.addEventListener("click", () => {
      btn.classList.toggle("is-active");
      filters.classList.remove("is-active");
      filtersMobile.classList.toggle("is-active");
      document.body.classList.toggle('mobile-filters-open');
    });
  });
}
const tabs = document.querySelector(".js-tabs");
if (tabs) {
  let tabsHead = tabs.querySelector(".tabs__head");
  let tabsPanels = tabs.querySelectorAll(".tabs__panel");
  tabsHead.addEventListener("click", function(e) {
    if (e.target.tagName !== "BUTTON")
      return;
    Array.from(tabsHead.children).forEach(function(button) {
      button.classList.remove("is-active");
    });
    e.target.classList.add("is-active");
    tabsPanels.forEach(function(panel2) {
      panel2.classList.remove("is-active");
    });
    let panelId = e.target.getAttribute("data-panel");
    let panel = document.getElementById(panelId);
    panel.classList.add("is-active");
  });
}
// const quantityElements = document.querySelectorAll(".js-quantity");
// if (quantityElements.length) {
//   quantityElements.forEach((quantityElement) => {
//     const input = quantityElement.querySelector(".js-quantity-input");
//     const buttons = quantityElement.querySelectorAll(".js-quantity-button");
//     buttons.forEach((button) => {
//       button.addEventListener("click", function(e) {

//         e.preventDefault();
//         const type = this.getAttribute("data-type");
//         let inputValue = parseInt(input.value);
//         if (type === "minus" && inputValue > 1) {
//           inputValue--;
//         } else if (type === "increment") {
//           inputValue++;
//         }
//         input.value = inputValue;
//       });
//     });
//   });
// }
const cartTable = document.querySelector(".cart-table table");
const cartSection = document.querySelector(".js-cart-section-shell");
const checkIfCartIsEmpty = () => {
  const rowCount = cartTable.querySelectorAll("tr").length;
  if (rowCount <= 1) {
    const emptyStateElement = document.createElement("div");
    emptyStateElement.className = "cart-section__empty";
    emptyStateElement.innerHTML = "<h2>The Cart is Empty</h2>";
    cartSection.innerHTML = "";
    cartSection.appendChild(emptyStateElement);
  }
};
const removeButtons = document.querySelectorAll(".js-cart-remove-btn");
if (removeButtons.length) {
  removeButtons.forEach((removeButton) => {
    removeButton.addEventListener("click", function(e) {
      e.preventDefault();
      const closestTableRow = this.closest("tr");
      closestTableRow.remove();
      checkIfCartIsEmpty();
    });
  });
  checkIfCartIsEmpty();
}
const accordionTriggers = document.querySelectorAll(".js-accordion-toggle");
const accordionFocusableSelector = "a, button, input, select, textarea, [tabindex]:not([tabindex='-1'])";
const setAccordionItemState = (accordionItem, isOpen) => {
  if (!accordionItem) {
    return;
  }
  const head = accordionItem.querySelector(".js-accordion-toggle");
  const body = accordionItem.querySelector(".accordion__body");
  accordionItem.classList.toggle("is-active", isOpen);
  head?.setAttribute("aria-expanded", isOpen ? "true" : "false");
  if (!body) {
    return;
  }
  body.setAttribute("aria-hidden", isOpen ? "false" : "true");
  if (isOpen) {
    body.removeAttribute("inert");
  } else {
    body.setAttribute("inert", "");
  }
  body.querySelectorAll(accordionFocusableSelector).forEach((focusable) => {
    if (isOpen) {
      if (focusable.hasAttribute("data-accordion-previous-tabindex")) {
        focusable.setAttribute("tabindex", focusable.getAttribute("data-accordion-previous-tabindex"));
        focusable.removeAttribute("data-accordion-previous-tabindex");
      } else if (focusable.getAttribute("tabindex") === "-1") {
        focusable.removeAttribute("tabindex");
      }
      return;
    }
    if (focusable.hasAttribute("tabindex")) {
      focusable.setAttribute("data-accordion-previous-tabindex", focusable.getAttribute("tabindex"));
    }
    focusable.setAttribute("tabindex", "-1");
  });
};
const closeAccordionItem = (accordionItem, { restoreFocus = false } = {}) => {
  if (!accordionItem?.classList.contains("is-active")) {
    return false;
  }
  const head = accordionItem.querySelector(".js-accordion-toggle");
  setAccordionItemState(accordionItem, false);
  if (restoreFocus) {
    head?.focus();
  }
  return true;
};
const closeFirstOpenAccordion = (scope, options) => {
  const openAccordion = scope?.querySelector(".js-accordion-container.is-active");
  return closeAccordionItem(openAccordion, options);
};
if (accordionTriggers.length) {
  accordionTriggers.forEach((head, index) => {
    const accordionItem = head.closest(".js-accordion-container");
    const body = accordionItem?.querySelector(".accordion__body");
    if (accordionItem && body && !body.id) {
      body.id = `AccordionBody-${index}`;
    }
    if (body?.id) {
      head.setAttribute("aria-controls", body.id);
    }
    head.setAttribute("aria-expanded", accordionItem?.classList.contains("is-active") ? "true" : "false");
    setAccordionItemState(accordionItem, accordionItem?.classList.contains("is-active"));
    head.addEventListener("click", () => {
      setAccordionItemState(accordionItem, !accordionItem.classList.contains("is-active"));
    });
    accordionItem?.addEventListener("keydown", (event) => {
      if (!isEscapeKey(event) || !closeAccordionItem(accordionItem, { restoreFocus: true })) {
        return;
      }
      event.preventDefault();
      event.stopPropagation();
    });
  });
}
const $window = $(window);
$(document);
const $body = $("body");
const $header = $(".header");
let headerHeight = $header.outerHeight();
let scrollHeight = $window.scrollTop();
let isDrawerLayoutTransitioning = false;
let drawerLayoutFrame = null;
$window.on("load", () => {
}).on("load scroll", () => {
  scrollHeight = $window.scrollTop();
}).on("load resize", () => {
  headerHeight = $header.outerHeight();
});
const miniCartToggle = document.querySelectorAll(".js-mini-cart-toggle");
const miniCart = document.querySelector(".js-mini-cart");
const isEscapeKey = (event) => event.key === "Escape" || event.key === "Esc" || event.code === "Escape";
const getPopupDialog = (popupHolder) => popupHolder?.querySelector(".popup__inner, .mini-cart__inner");
const getPopupInitialFocus = (popupHolder) => popupHolder?.querySelector(".js-popup-close, .popup__close, .mini-cart__close, button, [href], input, select, textarea, [tabindex]:not([tabindex='-1'])");
const focusWithoutScroll = (element) => {
  if (typeof element?.focus !== "function") {
    return;
  }
  try {
    element.focus({ preventScroll: true });
  } catch (error) {
    element.focus();
  }
};
const setPopupHolderState = (popupHolder, isOpen) => {
  if (!popupHolder) {
    return;
  }
  popupHolder.classList.toggle("is-active", isOpen);
  popupHolder.setAttribute("aria-hidden", isOpen ? "false" : "true");
  if (isOpen) {
    popupHolder.removeAttribute("inert");
  } else {
    popupHolder.setAttribute("inert", "");
  }
  const dialog = getPopupDialog(popupHolder);
  if (dialog && !dialog.hasAttribute("tabindex")) {
    dialog.setAttribute("tabindex", "-1");
  }
};
document.querySelectorAll(".js-popup-holder").forEach((popupHolder) => {
  setPopupHolderState(popupHolder, popupHolder.classList.contains("is-active"));
});
const syncPopupBodyState = () => {
  const hasActivePopup = document.querySelector(".js-popup-holder.is-active");
  const hasActiveMiniCart = document.querySelector(".js-mini-cart.is-active");
  $body.toggleClass("is-mini-cart-open", Boolean(hasActivePopup || hasActiveMiniCart));
};
const closePopupHolder = (popupHolder, { restoreFocus = false } = {}) => {
  if (!popupHolder) {
    return;
  }
  setPopupHolderState(popupHolder, false);
  if (popupHolder.id) {
    const popupSelector = `#${popupHolder.id}`;
    document.querySelectorAll(`.js-popup-trigger[data-popup-target="${popupSelector}"], .js-popup-trigger[href="${popupSelector}"]`).forEach((trigger) => {
      trigger.setAttribute("aria-expanded", "false");
    });
  }
  if (restoreFocus && popupHolder.__triggerElement && typeof popupHolder.__triggerElement.focus === "function") {
    focusWithoutScroll(popupHolder.__triggerElement);
  }
  syncPopupBodyState();
};
const closeMiniCart = () => {
  if (!miniCart) {
    return;
  }
  setPopupHolderState(miniCart, false);
  syncPopupBodyState();
};
const openMiniCart = ({ focusCart = false, triggeredBy = null } = {}) => {
  if (!miniCart) {
    return;
  }
  prepareDrawerOpening(miniCart);
  if (triggeredBy) {
    miniCart.__triggerElement = triggeredBy;
  }
  setPopupHolderState(miniCart, true);
  syncPopupBodyState();
  if (focusCart) {
    const focusTarget = getPopupInitialFocus(miniCart) || getPopupDialog(miniCart);
    focusWithoutScroll(focusTarget);
  }
};
if (miniCartToggle.length && miniCart) {
  miniCartToggle.forEach((toggle) => {
    toggle.addEventListener("click", () => {
      const shouldOpen = !miniCart.classList.contains("is-active");
      if (shouldOpen) {
        openMiniCart({ focusCart: true, triggeredBy: toggle });
      } else {
        setPopupHolderState(miniCart, false);
        syncPopupBodyState();
      }
    });
  });
}
function getVisibleAnnouncementHeight() {
  const announcementBar = document.querySelector(".announcement-bar");
  if (!announcementBar) {
    return 0;
  }
  const styles = window.getComputedStyle(announcementBar);
  if (styles.display === "none" || styles.visibility === "hidden" || styles.opacity === "0") {
    return 0;
  }
  const rect = announcementBar.getBoundingClientRect();
  const visibleTop = Math.max(rect.top, 0);
  const visibleBottom = Math.min(rect.bottom, window.innerHeight || document.documentElement.clientHeight);
  return Math.max(0, Math.round(visibleBottom - visibleTop));
}
function updateDrawerLayoutMetrics() {
  const headerElement = document.querySelector(".header");
  const headerRect = headerElement?.getBoundingClientRect();
  const currentHeaderHeight = Math.round(headerRect?.height || headerHeight || 0);
  const headerBottom = Math.max(0, Math.round(headerRect?.bottom || currentHeaderHeight));
  const announcementHeight = getVisibleAnnouncementHeight();
  const drawerOffset = Math.max(0, Math.max(headerBottom, currentHeaderHeight + announcementHeight) - 1);
  const viewportHeight = Math.round(window.visualViewport?.height || window.innerHeight || document.documentElement.clientHeight);
  const drawerHeight = Math.max(0, viewportHeight - drawerOffset);
  document.documentElement.style.setProperty("--header-height", `${currentHeaderHeight}px`);
  document.documentElement.style.setProperty("--announcement-height", `${announcementHeight}px`);
  document.documentElement.style.setProperty("--drawer-offset", `${drawerOffset}px`);
  document.documentElement.style.setProperty("--drawer-height", `${drawerHeight}px`);
  $body.css({
    "--header-height": `${currentHeaderHeight}px`,
    "--announcement-height": `${announcementHeight}px`,
    "--drawer-offset": `${drawerOffset}px`,
    "--drawer-height": `${drawerHeight}px`
  });
}
function freezeDrawerLayoutDuringTransition() {
  isDrawerLayoutTransitioning = true;
  if (drawerLayoutFrame !== null) {
    window.cancelAnimationFrame(drawerLayoutFrame);
    drawerLayoutFrame = null;
  }
  window.setTimeout(() => {
    isDrawerLayoutTransitioning = false;
    updateDrawerLayoutMetrics();
  }, 350);
}
function prepareDrawerOpening(popupHolder) {
  updateDrawerLayoutMetrics();
  popupHolder?.getBoundingClientRect();
  freezeDrawerLayoutDuringTransition();
}
const scheduleDrawerLayoutMetricsUpdate = () => {
  if (isDrawerLayoutTransitioning) {
    return;
  }
  if (drawerLayoutFrame !== null) {
    return;
  }
  drawerLayoutFrame = window.requestAnimationFrame(() => {
    drawerLayoutFrame = null;
    if (isDrawerLayoutTransitioning) {
      return;
    }
    updateDrawerLayoutMetrics();
  });
};
$window.on("load resize scroll orientationchange drawer-layout-change", scheduleDrawerLayoutMetricsUpdate);
window.visualViewport?.addEventListener("resize", scheduleDrawerLayoutMetricsUpdate);
window.visualViewport?.addEventListener("scroll", scheduleDrawerLayoutMetricsUpdate);
document.addEventListener("DOMContentLoaded", () => {
  updateDrawerLayoutMetrics();
  const watchedLayoutElements = [document.querySelector(".header"), document.querySelector(".announcement-bar")].filter(Boolean);
  if ("ResizeObserver" in window) {
    const drawerLayoutResizeObserver = new ResizeObserver(scheduleDrawerLayoutMetricsUpdate);
    watchedLayoutElements.forEach((element) => drawerLayoutResizeObserver.observe(element));
  }
  if ("MutationObserver" in window) {
    const drawerLayoutMutationObserver = new MutationObserver(scheduleDrawerLayoutMetricsUpdate);
    watchedLayoutElements.forEach((element) => {
      drawerLayoutMutationObserver.observe(element, {
        attributes: true,
        attributeFilter: ["class", "style", "hidden"]
      });
    });
  }
});
updateDrawerLayoutMetrics();
const personaliaztion = document.querySelector(".js-personalization");
const getLegacyPersonalizationDialog = () => personaliaztion?.querySelector(".personalization__inner");
const getLegacyPersonalizationInitialFocus = () => personaliaztion?.querySelector(".field__input, button, [href], input, select, textarea, [tabindex]:not([tabindex='-1'])");
const setLegacyPersonalizationState = (isOpen) => {
  if (!personaliaztion) {
    return;
  }
  personaliaztion.classList.toggle("is-active", isOpen);
  personaliaztion.setAttribute("aria-hidden", isOpen ? "false" : "true");
  if (isOpen) {
    personaliaztion.removeAttribute("inert");
  } else {
    personaliaztion.setAttribute("inert", "");
  }
  const dialog = getLegacyPersonalizationDialog();
  if (dialog && !dialog.hasAttribute("tabindex")) {
    dialog.setAttribute("tabindex", "-1");
  }
};
const closeLegacyPersonalization = ({ restoreFocus = false } = {}) => {
  if (!personaliaztion) {
    return;
  }
  setLegacyPersonalizationState(false);
  if (restoreFocus && personaliaztion.__triggerElement && typeof personaliaztion.__triggerElement.focus === "function") {
    personaliaztion.__triggerElement.focus();
  }
};
if (personaliaztion) {
  const trigger = document.querySelectorAll(".js-personalization-trigger");
  const typographyLabels = document.querySelectorAll(".js-typography-list label");
  const personalizationForm = document.querySelector(".js-personalization-form");
  setLegacyPersonalizationState(personaliaztion.classList.contains("is-active"));
  trigger.forEach((element) => {
    element.addEventListener("click", (event) => {
      if (element.tagName === "A") {
        event.preventDefault();
      }
      const isInsideDrawer = personaliaztion.contains(element);
      if (isInsideDrawer) {
        closeLegacyPersonalization({ restoreFocus: true });
        return;
      }
      personaliaztion.__triggerElement = element;
      setLegacyPersonalizationState(true);
      const focusTarget = getLegacyPersonalizationInitialFocus() || getLegacyPersonalizationDialog();
      focusTarget?.focus();
    });
  });
  typographyLabels.forEach((button) => {
    button.addEventListener("click", (event) => {
      typographyLabels.forEach((btn) => btn.classList.remove("is-active"));
      event.currentTarget.classList.add("is-active");
    });
  });
  if (personalizationForm) {
    personalizationForm.addEventListener("submit", (e) => {
      e.preventDefault();
    });
  }
}
let $menuMobileHolder = $(".menu-mobile");
$(".nav-header > ul > li > a").each((index, mainLink) => {
  let $mainLink = $(mainLink);
  $mainLink.parent().find(".mega-menu__inner").prepend(`
		<div class="mega__head mega-sec__head visible-xs-block visible-sm-block">
			<a href="#" class="btn-back js-main-back"><span>Back</span></a>

			<p>${$mainLink.html()}</p>
		</div>
	`).find(".js-main-back").on("click", (e) => {
    let $this = $(e.currentTarget);
    $this.parents(".is-active").removeClass("is-active");
    $menuMobileHolder.removeClass("is-menu-sec");
  });
  $mainLink.on("click", (e) => {
    let $this = $(e.currentTarget);
    const hasSubmenu = $this.is("[aria-haspopup='true']");
    const isKeyboardActivation = hasSubmenu && (
      $this.attr("data-keyboard-open") === "true"
      || e.originalEvent?.detail === 0
    );

    $this.attr("data-keyboard-open", "false");

    if ($(window).width() <= 1024) {
      e.preventDefault(); // Prevent the default link behavior for mobile
      $this.parent().addClass("is-active").siblings().removeClass("is-active");
      $menuMobileHolder.addClass("is-menu-sec");
    } else if (isKeyboardActivation) {
      e.preventDefault();
      $this.parent().addClass("is-active").siblings().removeClass("is-active");
      $this.attr("aria-expanded", "true");
      $this.parent().find(".mega-menu__section-trigger, .mega-menu a, .mega-menu button").get(0)?.focus();
    } else {
      // On desktop, allow the link to work as usual
      window.location.href = $this.attr("href");
    }

  });
});
$(".mega-menu .mega-menu__navs nav").each((index, secMenu) => {
  let $secMenu = $(secMenu);
  let $title = $secMenu.children("p");
  $secMenu.find(".menu__tr-holder").prepend(
    `
		<div class="mega__head menu__tr-head visible-xs-block visible-sm-block">
			<a href="#" class="btn-back js-tr-back"><span>Back</span></a>
			<p>${$title.html()}</p>
		</div>`
  ).find(".js-tr-back").on("click", (e) => {
    let $this = $(e.currentTarget);
    $this.parents("nav.is-active").removeClass("is-active");
    $menuMobileHolder.removeClass("is-menu-thr");
  });
});
$(".mega-menu .mega-menu__navs nav > p").on("click", (e) => {
  let $this = $(e.currentTarget);
  $this.parent().addClass("is-active").siblings().removeClass("is-active");
  $menuMobileHolder.addClass("is-menu-thr");
});
$(".js-nav-trigger").on("click", (e) => {
  $(e.currentTarget);
  $body.toggleClass("is-menu-open");
});
let $sliderProducts = $(".js-product-carousel .swiper");
$sliderProducts.each((index, slider) => {
  new Swiper(slider, {
    loop: true,
    pagination: {
      el: ".swiper-pagination"
    }
  });
});
let sliderProductsScroll = () => {
  let $sliderHolder = $(".slider-products");
  let $sliderItems = $sliderHolder.find("a");
  $sliderItems.on("click", (e) => {
    e.preventDefault();
    let $this = $(e.currentTarget);
    swiper.slideTo($this.parent().index());
  });
  if ($(window).outerWidth() < 767) {
    var swiper = new Swiper($sliderHolder.find(".slider__main .swiper")[0], {
      effect: "fade",
      loop: true,
      zoom: true,
      direction: "horizontal",
      slidesPerView: 1,
      on: {
        slideChange: function(swiper2) {
          $sliderItems.eq(swiper2.realIndex).parent().addClass("is-active").siblings().removeClass("is-active");
        }
      }
    });
  } else {
    var swiper = new Swiper($sliderHolder.find(".slider__main .swiper")[0], {
      loop: false,
      direction: "vertical",
      freeMode: true,
      zoom: true,
      mousewheel: true,
      on: {
        slideChange: function(swiper2) {
          $sliderItems.eq(swiper2.activeIndex).parent().addClass("is-active").siblings().removeClass("is-active");
        }
      }
    });
  }
  $(".popup-gallery").find(".js-popup-back").on("click", (e) => {
    e.preventDefault();
    $(".popup-gallery").removeClass("is-visible");
  });
};
sliderProductsScroll();
function openProductGallery(trigger) {
  const gallery = document.querySelector(".popup-gallery");
  if (!gallery) return;

  const index = Number(trigger.dataset.productMediaIndex) || 0;
  gallery.classList.add("is-visible");
  const slider = gallery.querySelector(".slider__main .swiper");
  const swiper = slider && slider.swiper;
  if (swiper) {
    swiper.update();
    if (swiper.params.loop) swiper.slideToLoop(index, 0);
    else swiper.slideTo(index, 0);
  }

  // Keep HD URLs inert until opening; let native lazy loading handle other slides.
  const selected = gallery.querySelector(`.image-zoom[data-product-media-index="${index}"]`);
  if (selected) selected.loading = "eager";
  gallery.querySelectorAll("img[data-zoom-src]").forEach((image) => {
    image.src = image.dataset.zoomSrc;
    image.removeAttribute("data-zoom-src");
  });
}
$(".js-popup-gallery").on("click", (e) => {
  e.preventDefault();
  openProductGallery(e.currentTarget);
});
let $stickySections = $(".js-sticky");
function stickyAside() {
  $stickySections.each(function(index, stickySection) {
    let $holder = $(stickySection);
    let $content = $holder.find(".sticky__content");
    let holderOffsetTop = $holder.offset().top;
    let contentHeight = $content.outerHeight();
    let contentWidth = $holder.outerWidth();
    $holder.css({
      "--content-height": contentHeight / 10 + "rem",
      "--content-width": contentWidth / 10 + "rem"
    });
    let stickyAreaStart = scrollHeight + headerHeight;
    let isSticky = stickyAreaStart >= holderOffsetTop;
    let contentHitBottom = stickyAreaStart + contentHeight > holderOffsetTop + $holder.outerHeight();
    $holder.toggleClass("is-sticky", isSticky);
    $holder.toggleClass("is-sticky-bottom", contentHitBottom);
  });
}
$(window).on("load scroll resize", () => {
  stickyAside();
});
$(window).on("load resize", function() {
  let vh = $(window).innerHeight();
  $("body").css("--win-height", vh + "px");
});
$(window).on("load resize", function() {
  fixedBreadcrumbs();
});
function fixedBreadcrumbs() {
  const holder = $(".js-fixed-breadcrumbs");
  const breadcrumbs = holder.find(".breadcrumbs");
  const breadcrumbsHeight = breadcrumbs.outerHeight();
  holder.css("--breadcrumbs-height", breadcrumbsHeight + "px");
}
$(".js-popup-close").on("click", function(e) {
  e.preventDefault();
  closePopupHolder(this.closest(".js-popup-holder"), { restoreFocus: true });
});
$(".js-popup-trigger").on("click", function(e) {
  const trigger = e.currentTarget;
  const target = trigger.dataset.popupTarget || trigger.getAttribute("href");
  if (!target || !target.startsWith("#")) {
    return;
  }
  e.preventDefault();
  const popupHolder = document.querySelector(target);
  if (!popupHolder) {
    return;
  }
  const shouldOpen = !popupHolder.classList.contains("is-active");
  document.querySelectorAll(".js-popup-holder.is-active").forEach((openPopup) => {
    if (openPopup !== popupHolder) {
      closePopupHolder(openPopup);
    }
  });
  if (shouldOpen) {
    prepareDrawerOpening(popupHolder);
    popupHolder.__triggerElement = trigger;
    setPopupHolderState(popupHolder, true);
    trigger.setAttribute("aria-expanded", "true");
    const focusTarget = getPopupInitialFocus(popupHolder) || getPopupDialog(popupHolder);
    focusWithoutScroll(focusTarget);
  } else {
    closePopupHolder(popupHolder, { restoreFocus: true });
  }
  syncPopupBodyState();
});
document.addEventListener("keydown", (event) => {
  if (!isEscapeKey(event)) {
    return;
  }
  const activePopup = document.querySelector(".js-popup-holder.is-active");
  if (activePopup) {
    if (closeFirstOpenAccordion(activePopup, { restoreFocus: true })) {
      event.preventDefault();
      return;
    }
    event.preventDefault();
    closePopupHolder(activePopup, { restoreFocus: true });
    return;
  }
  if (miniCart?.classList.contains("is-active")) {
    event.preventDefault();
    closeMiniCart();
    return;
  }
  const popupGallery = document.querySelector(".popup-gallery.is-visible");
  if (popupGallery) {
    event.preventDefault();
    popupGallery.classList.remove("is-visible");
    return;
  }
  const personalization = document.querySelector(".js-personalization.is-active");
  if (personalization) {
    event.preventDefault();
    closeLegacyPersonalization({ restoreFocus: true });
  }
});
if (document.querySelector(".js-wishlist-slider")) {
  setTimeout(() => {
    let splide = new Splide(".js-wishlist-slider", {
      arrows: false,
      pagination: false,
      autoWidth: true,
      type: "loop",
      gap: "3rem",
      breakpoints: {
        640: {
          gap: "1.4rem"
        }
      }
    });
    splide.mount();
  }, 500);
}
$(document).on("click", ".js-add-to-cart-button", (e) => {
  e.preventDefault();
  const productId = $(e.target).data("variant-id");
  window.ShpCustom.Cart.addItemFromForm(
    { id: productId, quantity: 1 },
    () => {
      window.ShpCustom.Cart.onItemAdded(lineItem);

    }
  );
});

$("form[id='ajax-add-to-cart']").on("submit", function(e) {
  e.preventDefault();
  e.stopImmediatePropagation();

  const $form = $(this);
  const $allButtons = $form.find(".js-add-to-cart");

  $allButtons.attr("disabled", "disabled");

  window.ShpCustom.Cart.addItemFromForm($form.serialize(), () => {
    $allButtons.removeAttr("disabled");
    window.ShpCustom.Cart.getCart();
  });
});


window.ShpCustom = window.ShpCustom || { Cart: {} };
window.ShpCustom.Cart.onItemAdded = function() {
  cart = window.ShpCustom.Cart.getCart();

};
window.ShpCustom.Cart.onError = function() {
  console.log("ShpCustom error");
};
window.ShpCustom.Cart.getCart = function() {

  let countryUrl = document.location.pathname.split("/")[1];
  if (countryUrl !== "zh" && countryUrl !== "es") {
    countryUrl = "";
  } else {
    countryUrl = `/${countryUrl}`;
  }
  const params = {
    type: "GET",
    url: `${countryUrl}/cart?view=mini`,
    success(lineHtml) {
      if (lineHtml) {
        const jQueryLineCount = $(lineHtml).find("#mini-cart-count");
        $(".js-mini-cart").find("#mini-cart-count").replaceWith(jQueryLineCount);
        const jQueryLineBody = $(lineHtml).find(".mini-cart__body");
        $(".js-mini-cart").find(".mini-cart__body").replaceWith(jQueryLineBody);
        const jQueryLineButtons = $(lineHtml).find(".mini-cart__buttons");
        $(".js-mini-cart").find(".mini-cart__buttons").replaceWith(jQueryLineButtons);
        openMiniCart({ focusCart: true });
      }
    },
    error(XMLHttpRequest, textStatus) {
      window.ShpCustom.Cart.onError(XMLHttpRequest, textStatus);
    }
  };
  $.ajax(params);
};
window.ShpCustom.Cart.updateCart = function(changeset) {

  window.Shopify.routes.root;
  var headers = new Headers({ "Content-Type": "application/json" });
  var request = {
    method: "POST",
    headers,
    body: JSON.stringify({ updates: changeset})
  };
  fetch("/cart/update.js", request).then(function(response) {
    response.json().then(function(json) {
      window.Nosto?.reloadCart();
      let cart = window.ShpCustom.Cart.getCart();
      window.dispatchCartUpdate(cart, 'updateCart');
    });
  });
};
window.ShpCustom.Cart.updateCartAndReload = function(updates, productIndex) {
  const removeButton = document.getElementById('remove-button-' + productIndex);

  if (removeButton) {
    // Disable the button to prevent multiple clicks
    removeButton.disabled = true;
    // Hide the button text
    const buttonText = removeButton.querySelector('.button-text');
    if (buttonText) {
      buttonText.style.display = 'none';
    }
    // Show the spinner
    const buttonSpinner = removeButton.querySelector('.button-spinner');
    if (buttonSpinner) {
      buttonSpinner.style.display = 'inline-block';
    }
  }
  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ updates: updates })
  })
  .then(response => response.json())
  .then(cart => {
    // Reload the cart page
    window.dispatchCartUpdate(cart, 'updateCartAndReload');

    location.reload();
  })
  .catch(error => {
    console.error('Error updating cart:', error);
    if (removeButton) {
       removeButton.disabled = false;
       // Show the button text
       if (buttonText) {
         buttonText.style.display = '';
       }
       // Hide the spinner
       if (buttonSpinner) {
         buttonSpinner.style.display = 'none';
       }
     }
  });
};

window.ShpCustom.Cart.removeCustomizedProduct = function(productIndex) {
  // Fetch the cart data
  const removeButton = document.getElementById('remove-button-' + productIndex);

  if (removeButton) {
    // Disable the button to prevent multiple clicks
    removeButton.disabled = true;
    // Hide the button text
    const buttonText = removeButton.querySelector('.button-text');
    if (buttonText) {
      buttonText.style.display = 'none';
    }
    // Show the spinner
    const buttonSpinner = removeButton.querySelector('.button-spinner');
    if (buttonSpinner) {
      buttonSpinner.style.display = 'inline-block';
    }
  }
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      let updates = {};
      let productItem = cart.items[productIndex];

      // Remove the product
      updates[productItem.key] = 0;

      // Find the associated customization
      let customizationItem = cart.items[productIndex + 1]

      // Remove the associated customization if it exists
      if (customizationItem) {
        updates[customizationItem.key] = 0;
      }

      // Update the cart and reload the page
      window.ShpCustom.Cart.updateCartAndReload(updates);
    })
    .catch(error => {
      console.error('Error removing customized product:', error);
      if (removeButton) {
         removeButton.disabled = false;
         // Show the button text
         if (buttonText) {
           buttonText.style.display = '';
         }
         // Hide the spinner
         if (buttonSpinner) {
           buttonSpinner.style.display = 'none';
         }
       }
    });
};


window.ShpCustom.Cart.addItemFromForm = function(data, callback) {
  let countryUrl = document.location.pathname.split("/")[1];
  if (countryUrl !== "zh" && countryUrl !== "es") {
    countryUrl = "";
  } else {
    countryUrl = `/${countryUrl}`;
  }
  console.log("app js")

  const params = {
    type: "POST",
    url: `${countryUrl}/cart/add.js`,
    data,
    dataType: "json",
    success(lineItem) {
      if (typeof callback === "function") {
        callback();
      }
      window.Nosto?.reloadCart();
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => window.dispatchCartUpdate(cart, 'addItemFromForm'));
    },
    error(XMLHttpRequest, textStatus) {
      if (typeof callback === "function") {
        callback();
      }
      window.ShpCustom.Cart.onError(XMLHttpRequest, textStatus);
    }
  };
  $.ajax(params);
};
$(".js-occurrence").on("click", function() {
  const title = $(this).find("h2").text();
  const icon = $(this).find("img").attr("src");
  const content = $(this).find(".js-content").html();
  $(".js-title-occurrence").text(title);
  $(".js-image-occurrence").attr("src", icon);
  $(".js-body-occurrence").html(content);
});
(function(a) {
  var r = a.fn.domManip, d = "_tmplitem", q = /^[^<]*(<[\w\W]+>)[^>]*$|\{\{\! /, b = {}, f = {}, e, p = { key: 0, data: {} }, h = 0, c = 0, l = [];
  function g(e2, d2, g2, i2) {
    var c2 = {
      data: i2 || (d2 ? d2.data : {}),
      _wrap: d2 ? d2._wrap : null,
      tmpl: null,
      parent: d2 || null,
      nodes: [],
      calls: u,
      nest: w,
      wrap: x,
      html: v,
      update: t
    };
    e2 && a.extend(c2, e2, { nodes: [], parent: d2 });
    if (g2) {
      c2.tmpl = g2;
      c2._ctnt = c2._ctnt || c2.tmpl(a, c2);
      c2.key = ++h;
      (l.length ? f : b)[h] = c2;
    }
    return c2;
  }
  a.each(
    {
      appendTo: "append",
      prependTo: "prepend",
      insertBefore: "before",
      insertAfter: "after",
      replaceAll: "replaceWith"
    },
    function(f2, d2) {
      a.fn[f2] = function(n2) {
        var g2 = [], i2 = a(n2), k2, h2, m2, l2, j2 = this.length === 1 && this[0].parentNode;
        e = b || {};
        if (j2 && j2.nodeType === 11 && j2.childNodes.length === 1 && i2.length === 1) {
          i2[d2](this[0]);
          g2 = this;
        } else {
          for (h2 = 0, m2 = i2.length; h2 < m2; h2++) {
            c = h2;
            k2 = (h2 > 0 ? this.clone(true) : this).get();
            a.fn[d2].apply(a(i2[h2]), k2);
            g2 = g2.concat(k2);
          }
          c = 0;
          g2 = this.pushStack(g2, f2, i2.selector);
        }
        l2 = e;
        e = null;
        a.tmpl.complete(l2);
        return g2;
      };
    }
  );
  a.fn.extend({
    tmpl: function(d2, c2, b2) {
      return a.tmpl(this[0], d2, c2, b2);
    },
    tmplItem: function() {
      return a.tmplItem(this[0]);
    },
    template: function(b2) {
      return a.template(b2, this[0]);
    },
    domManip: function(d2, l2, j2) {
      if (d2[0] && d2[0].nodeType) {
        var f2 = a.makeArray(arguments), g2 = d2.length, i2 = 0, h2;
        while (i2 < g2 && !(h2 = a.data(d2[i2++], "tmplItem")))
          ;
        if (g2 > 1)
          f2[0] = [a.makeArray(d2)];
        if (h2 && c)
          f2[2] = function(b2) {
            a.tmpl.afterManip(this, b2, j2);
          };
        r.apply(this, f2);
      } else
        r.apply(this, arguments);
      c = 0;
      !e && a.tmpl.complete(b);
      return this;
    }
  });
  a.extend({
    tmpl: function(d2, h2, e2, c2) {
      var j2, k2 = !c2;
      if (k2) {
        c2 = p;
        d2 = a.template[d2] || a.template(null, d2);
        f = {};
      } else if (!d2) {
        d2 = c2.tmpl;
        b[c2.key] = c2;
        c2.nodes = [];
        c2.wrapped && n(c2, c2.wrapped);
        return a(i(c2, null, c2.tmpl(a, c2)));
      }
      if (!d2)
        return [];
      if (typeof h2 === "function")
        h2 = h2.call(c2 || {});
      e2 && e2.wrapped && n(e2, e2.wrapped);
      j2 = a.isArray(h2) ? a.map(h2, function(a2) {
        return a2 ? g(e2, c2, d2, a2) : null;
      }) : [g(e2, c2, d2, h2)];
      return k2 ? a(i(c2, null, j2)) : j2;
    },
    tmplItem: function(b2) {
      var c2;
      if (b2 instanceof a)
        b2 = b2[0];
      while (b2 && b2.nodeType === 1 && !(c2 = a.data(b2, "tmplItem")) && (b2 = b2.parentNode))
        ;
      return c2 || p;
    },
    template: function(c2, b2) {
      if (b2) {
        if (typeof b2 === "string")
          b2 = o(b2);
        else if (b2 instanceof a)
          b2 = b2[0] || {};
        if (b2.nodeType)
          b2 = a.data(b2, "tmpl") || a.data(b2, "tmpl", o(b2.innerHTML));
        return typeof c2 === "string" ? a.template[c2] = b2 : b2;
      }
      return c2 ? typeof c2 !== "string" ? a.template(null, c2) : a.template[c2] || a.template(null, q.test(c2) ? c2 : a(c2)) : null;
    },
    encode: function(a2) {
      return ("" + a2).split("<").join("&lt;").split(">").join("&gt;").split('"').join("&#34;").split("'").join("&#39;");
    }
  });
  a.extend(a.tmpl, {
    tag: {
      tmpl: {
        _default: { $2: "null" },
        open: "if($notnull_1){_=_.concat($item.nest($1,$2));}"
      },
      wrap: {
        _default: { $2: "null" },
        open: "$item.calls(_,$1,$2);_=[];",
        close: "call=$item.calls();_=call._.concat($item.wrap(call,_));"
      },
      each: {
        _default: { $2: "$index, $value" },
        open: "if($notnull_1){$.each($1a,function($2){with(this){",
        close: "}});}"
      },
      if: { open: "if(($notnull_1) && $1a){", close: "}" },
      else: {
        _default: { $1: "true" },
        open: "}else if(($notnull_1) && $1a){"
      },
      html: { open: "if($notnull_1){_.push($1a);}" },
      "=": {
        _default: { $1: "$data" },
        open: "if($notnull_1){_.push($.encode($1a));}"
      },
      "!": { open: "" }
    },
    complete: function() {
      b = {};
    },
    afterManip: function(f2, b2, d2) {
      var e2 = b2.nodeType === 11 ? a.makeArray(b2.childNodes) : b2.nodeType === 1 ? [b2] : [];
      d2.call(f2, b2);
      m(e2);
      c++;
    }
  });
  function i(e2, g2, f2) {
    var b2, c2 = f2 ? a.map(f2, function(a2) {
      return typeof a2 === "string" ? e2.key ? a2.replace(
        /(<\w+)(?=[\s>])(?![^>]*_tmplitem)([^>]*)/g,
        "$1 " + d + '="' + e2.key + '" $2'
      ) : a2 : i(a2, e2, a2._ctnt);
    }) : e2;
    if (g2)
      return c2;
    c2 = c2.join("");
    c2.replace(
      /^\s*([^<\s][^<]*)?(<[\w\W]+>)([^>]*[^>\s])?\s*$/,
      function(f3, c3, e3, d2) {
        b2 = a(e3).get();
        m(b2);
        if (c3)
          b2 = j(c3).concat(b2);
        if (d2)
          b2 = b2.concat(j(d2));
      }
    );
    return b2 ? b2 : j(c2);
  }
  function j(c2) {
    var b2 = document.createElement("div");
    b2.innerHTML = c2;
    return a.makeArray(b2.childNodes);
  }
  function o(b2) {
    return new Function(
      "jQuery",
      "$item",
      "var $=jQuery,call,_=[],$data=$item.data;with($data){_.push('" + a.trim(b2).replace(/([\\'])/g, "\\$1").replace(/[\r\t\n]/g, " ").replace(/\$\{([^\}]*)\}/g, "{{= $1}}").replace(
        /\{\{(\/?)(\w+|.)(?:\(((?:[^\}]|\}(?!\}))*?)?\))?(?:\s+(.*?)?)?(\(((?:[^\}]|\}(?!\}))*?)\))?\s*\}\}/g,
        function(m2, l2, j2, d2, b3, c2, e2) {
          var i2 = a.tmpl.tag[j2], h2, f2, g2;
          if (!i2)
            throw "Template command not found: " + j2;
          h2 = i2._default || [];
          if (c2 && !/\w$/.test(b3)) {
            b3 += c2;
            c2 = "";
          }
          if (b3) {
            b3 = k(b3);
            e2 = e2 ? "," + k(e2) + ")" : c2 ? ")" : "";
            f2 = c2 ? b3.indexOf(".") > -1 ? b3 + c2 : "(" + b3 + ").call($item" + e2 : b3;
            g2 = c2 ? f2 : "(typeof(" + b3 + ")==='function'?(" + b3 + ").call($item):(" + b3 + "))";
          } else
            g2 = f2 = h2.$1 || "null";
          d2 = k(d2);
          return "');" + i2[l2 ? "close" : "open"].split("$notnull_1").join(
            b3 ? "typeof(" + b3 + ")!=='undefined' && (" + b3 + ")!=null" : "true"
          ).split("$1a").join(g2).split("$1").join(f2).split("$2").join(
            d2 ? d2.replace(
              /\s*([^\(]+)\s*(\((.*?)\))?/g,
              function(d3, c3, b4, a2) {
                a2 = a2 ? "," + a2 + ")" : b4 ? ")" : "";
                return a2 ? "(" + c3 + ").call($item" + a2 : d3;
              }
            ) : h2.$2 || ""
          ) + "_.push('";
        }
      ) + "');}return _;"
    );
  }
  function n(c2, b2) {
    c2._wrap = i(c2, true, a.isArray(b2) ? b2 : [q.test(b2) ? b2 : a(b2).html()]).join(
      ""
    );
  }
  function k(a2) {
    return a2 ? a2.replace(/\\'/g, "'").replace(/\\\\/g, "\\") : null;
  }
  function s(b2) {
    var a2 = document.createElement("div");
    a2.appendChild(b2.cloneNode(true));
    return a2.innerHTML;
  }
  function m(o2) {
    var n2 = "_" + c, k2, j2, l2 = {}, e2, p2, i2;
    for (e2 = 0, p2 = o2.length; e2 < p2; e2++) {
      if ((k2 = o2[e2]).nodeType !== 1)
        continue;
      j2 = k2.getElementsByTagName("*");
      for (i2 = j2.length - 1; i2 >= 0; i2--)
        m2(j2[i2]);
      m2(k2);
    }
    function m2(j3) {
      var p3, i3 = j3, k3, e3, m3;
      if (m3 = j3.getAttribute(d)) {
        while (i3.parentNode && (i3 = i3.parentNode).nodeType === 1 && !(p3 = i3.getAttribute(d)))
          ;
        if (p3 !== m3) {
          i3 = i3.parentNode ? i3.nodeType === 11 ? 0 : i3.getAttribute(d) || 0 : 0;
          if (!(e3 = b[m3])) {
            e3 = f[m3];
            e3 = g(e3, b[i3] || f[i3], null, true);
            e3.key = ++h;
            b[h] = e3;
          }
          c && o3(m3);
        }
        j3.removeAttribute(d);
      } else if (c && (e3 = a.data(j3, "tmplItem"))) {
        o3(e3.key);
        b[e3.key] = e3;
        i3 = a.data(j3.parentNode, "tmplItem");
        i3 = i3 ? i3.key : 0;
      }
      if (e3) {
        k3 = e3;
        while (k3 && k3.key != i3) {
          k3.nodes.push(j3);
          k3 = k3.parent;
        }
        delete e3._ctnt;
        delete e3._wrap;
        a.data(j3, "tmplItem", e3);
      }
      function o3(a2) {
        a2 = a2 + n2;
        e3 = l2[a2] = l2[a2] || g(e3, b[e3.parent.key + n2] || e3.parent, null, true);
      }
    }
  }
  function u(a2, d2, c2, b2) {
    if (!a2)
      return l.pop();
    l.push({ _: a2, tmpl: d2, item: this, data: c2, options: b2 });
  }
  function w(d2, c2, b2) {
    return a.tmpl(a.template(d2), c2, b2, this);
  }
  function x(b2, d2) {
    var c2 = b2.options || {};
    c2.wrapped = d2;
    return a.tmpl(a.template(b2.tmpl), b2.data, c2, b2.item);
  }
  function v(d2, c2) {
    var b2 = this._wrap;
    return a.map(
      a(a.isArray(b2) ? b2.join("") : b2).filter(d2 || "*"),
      function(a2) {
        return c2 ? a2.innerText || a2.textContent : a2.outerHTML || s(a2);
      }
    );
  }
  function t() {
    var b2 = this.nodes;
    a.tmpl(null, null, null, this).insertBefore(b2[0]);
    a(b2).remove();
  }
})(jQuery);
jQuery.cookie = function(b, j, m) {
  if (typeof j != "undefined") {
    m = m || {};
    if (j === null) {
      j = "";
      m.expires = -1;
    }
    var e = "";
    if (m.expires && (typeof m.expires == "number" || m.expires.toUTCString)) {
      var f;
      if (typeof m.expires == "number") {
        f = /* @__PURE__ */ new Date();
        f.setTime(f.getTime() + m.expires * 24 * 60 * 60 * 1e3);
      } else {
        f = m.expires;
      }
      e = "; expires=" + f.toUTCString();
    }
    var l = m.path ? "; path=" + m.path : "";
    var g = m.domain ? "; domain=" + m.domain : "";
    var a = m.secure ? "; secure" : "";
    document.cookie = [b, "=", encodeURIComponent(j), e, l, g, a].join("");
  } else {
    var d = null;
    if (document.cookie && document.cookie != "") {
      var k = document.cookie.split(";");
      for (var h = 0; h < k.length; h++) {
        var c = jQuery.trim(k[h]);
        if (c.substring(0, b.length + 1) == b + "=") {
          d = decodeURIComponent(c.substring(b.length + 1));
          break;
        }
      }
    }
    return d;
  }
};
window.Shopify.Products = function() {
  var a = {
    howManyToShow: 3,
    howManyToStoreInMemory: 10,
    wrapperId: "recently-viewed-products",
    templateId: "recently-viewed-product-template",
    onComplete: null
  };
  var c = [];
  var h = null;
  var d = null;
  var e = 0;
  var b = {
    configuration: { expires: 90, path: "/", domain: window.location.hostname },
    name: "shopify_recently_viewed",
    write: function(i) {
      jQuery.cookie(this.name, i.join(" "), this.configuration);
    },
    read: function() {
      var i = [];
      var j = jQuery.cookie(this.name);
      if (j !== null) {
        i = j.split(" ");
      }
      return i;
    },
    destroy: function() {
      jQuery.cookie(this.name, null, this.configuration);
    },
    remove: function(k) {
      var j = this.read();
      var i = jQuery.inArray(k, j);
      if (i !== -1) {
        j.splice(i, 1);
        this.write(j);
      }
    }
  };
  var f = function() {
    h.show();
    if (a.onComplete) {
      try {
        a.onComplete();
      } catch (i) {
      }
    }
  };
  var g = function() {
    let countryUrl = document.location.pathname.split("/")[1];
    if (countryUrl !== "zh" && countryUrl !== "es") {
      countryUrl = "";
    } else {
      countryUrl = `/${countryUrl}`;
    }
    if (c.length && e < a.howManyToShow) {
      jQuery.ajax({
        dataType: "json",
        url: countryUrl + "/products/" + c[0] + ".js",
        cache: false,
        success: function(i) {
          d.tmpl(i).appendTo(h);
          c.shift();
          e++;
          g();
        },
        error: function() {
          b.remove(c[0]);
          c.shift();
          g();
        }
      });
    } else {
      f();
    }
  };
  return {
    resizeImage: function(m, j) {
      if (j == null) {
        return m;
      }
      if (j == "master") {
        return m.replace(/http(s)?:/, "");
      }
      var i = m.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i);
      if (i != null) {
        var k = m.split(i[0]);
        var l = i[0];
        return (k[0] + "_" + j + l).replace(/http(s)?:/, "");
      } else {
        return null;
      }
    },
    showRecentlyViewed: function(i) {
      var i = i || {};
      jQuery.extend(a, i);
      c = b.read();
      d = jQuery("#" + a.templateId);
      h = jQuery("#" + a.wrapperId);
      a.howManyToShow = Math.min(c.length, a.howManyToShow);
      if (a.howManyToShow && d.length && h.length) {
        g();
      }
    },
    getConfig: function() {
      return a;
    },
    clearList: function() {
      b.destroy();
    },
    recordRecentlyViewed: function(l) {
      var l = l || {};
      jQuery.extend(a, l);
      var j = b.read();
      if (window.location.pathname.indexOf("/products/") !== -1) {
        var k = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/)[1];
        var i = jQuery.inArray(k, j);
        if (i === -1) {
          j.unshift(k);
          j = j.splice(0, a.howManyToStoreInMemory);
        } else {
          j.splice(i, 1);
          j.unshift(k);
        }
        b.write(j);
      }
    }
  };
}();
window.Shopify = window.Shopify || {};
window.Shopify.money_format = "${{amount}}";
window.Shopify.formatMoney = function(cents, format2) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format2 || this.money_format;
  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    var parts = number.split("."), dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), cents2 = parts[1] ? decimal + parts[1] : "";
    return dollars + cents2;
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, ".", " ");
      break
    default:
      value = formatWithDelimiters(cents, 0, ".", " ");
      break;
  }
  return formatString.replace(placeholderRegex, value);
};
$(".section__body").on("click", ".js-plus, .js-minus", function (e) {
  e.preventDefault();
  e.stopImmediatePropagation()

  const $wrap  = $(this).closest(".js-quantity");
  const $input = $wrap.find(".js-quantity-input");

  const key    = $wrap.data("key");          // ✅ unique
  const line   = $wrap.data("line");         // fallback possible
  const before = parseInt($input.val(), 10) || 0;
  const dir    = $(this).hasClass("js-minus") ? -1 : 1;
  const next   = Math.max(1, before + dir);

  console.log("[CART:QTY]", { before, next, key, line });

  const payload = key
    ? { id: key, quantity: next }            // ✅ cible la line via key
    : { line: line, quantity: next };        // ou via index 1-based

  $.post("/cart/change.js", payload)
    .done(() => { document.location.reload(); })
    .fail((xhr) => console.error("cart/change fail", xhr?.responseText || xhr));
});

$(".section__body").on("click", ".js-plus", (e) => {

  e.preventDefault();
  const parent = $(e.target).closest("div");
  const currentVal = parseInt(parent.find("input").val(), 10);
  const currentVariant = parseInt(parent.find("input").attr("id"), 10);
  jQuery.post("/cart/change.js", { quantity: currentVal + 1, id: currentVariant }).done(() => {
    document.location.reload();
  });
});
$(".js-popup-address").on("click", (e) => {
  e.preventDefault();
  const form = $(e.target).data("form");
  const container = $(e.target).data("container");
  $(container).find(".form").html($(form).html());
  $(container).addClass("is-active");
  $("body").addClass("no-scroll");
  $(".js-popup-close").on("click", (ev) => {
    ev.preventDefault();
    $(ev.target).closest(".js-popup-container").removeClass("is-active");
    $("body").removeClass("no-scroll");
  });
});

$("#contact-us-form").submit(function(e) {
  e.preventDefault();
  const iti = window.intlTelInputGlobals.getInstance(
    document.getElementById("phone_suffix")
  );
  if (iti.isValidNumber()) {
    $("#phone").val(iti.getNumber());
  }
  const dataForm = new FormData($(this));
  $.ajax({
    enctype: "multipart/form-data",
    processData: false,
    contentType: false,
    cache: false,
    url: "/apps/myjobboard/application",
    type: "post",
    dataForm,
    success(data) {
      if (data.result) {
        $(this).reset();
        $(".thanks").attr("style", "display:block !important");
        $("html, body").animate({ scrollTop: $("body").offset().top }, 750);
      }
    }
  });
});
$(".js-show-form").on("click", (e) => {
  e.preventDefault();
  $(e.currentTarget);
  $(".js-show-form-holder").addClass("hidden");
  $(".js-show-form-form").removeClass("hidden");
});
let $showMoreHolder = $(".js-show-more");
$showMoreHolder.each((index, holder) => {
  let $holder = $(holder);
  let $content = $holder.find(".show__content");
  let $actionsBtn = $holder.find(".js-more");
  let words = 0;
  $content.children().each((index2, paragraph) => {
    let $paragraph = $(paragraph);
    words += $paragraph.html().split(" ").length;
  });
  $actionsBtn.on("click", (e) => {
    e.preventDefault();
    $holder.toggleClass("is-content-visible");
    if ($holder.hasClass("is-content-visible")) {
      console.log($actionsBtn);
      $actionsBtn.find("span").text("less");
    } else {
      $actionsBtn.find("span").text("more");
    }
    $holder.find(".hidden-content").slideToggle();
  });
  $holder.toggleClass("has-content", words > 100);
});
$(".js-favorites").on("click", (e) => {
  e.preventDefault();
  let $this = $(e.currentTarget);
  $this.toggleClass("is-active");
});


if (document.querySelector("custom-personalisation")) {
  new Splide("custom-personalisation .images_panel", {
    type: "slide",
    perPage: 1,
    arrows: false,
    pagination: true,
    mediaQuery: 'min',
    breakpoints: {
      900: {
        destroy: true,
      },
    }
  }).mount();
}
